
const fees = 'Fees apply. See ' +
  '<a href="https://www.regions.com/virtualdocuments/Business_Pricing_Schedule.pdf" target="_blank" ' +
  'rel="noreferrer noreferrer">pricing schedule</a> or the current ' +
  '<a href="https://www.regions.com/virtualdocuments/Deposit_Agreement_6_1_2018.pdf" target="_blank" ' +
  'rel="noreferrer noreferrer">Regions Deposit Agreement</a> for complete terms.';
const pricing = 'https://www.regions.com/virtualdocuments/Business_Pricing_Schedule.pdf';
const deposit = 'https://www.regions.com/virtualdocuments/Deposit_Agreement_6_1_2018.pdf';

export default {
  /**
   * ============================
   * GENERAL MESSAGES
   * ============================
   */
  bank: 'Regions Bank',
  'nav.prev': 'Back',
  'nav.next': 'Next',
  pleaseSelect: 'Please select',
  cartButton: 'View Action Plan',
  'answersList.title': 'Your Answers',
  addToCart: 'Add to Cart',
  addedToCart: 'Added to cart',
  removeFromCart: 'Remove',
  backToRecommendations: 'Return to list of recommendations',

  'redirectMessage.summary': 'Path completed, loading recommendations...',
  'redirectMessage.path': 'Starting new path...',

  addToMaybeLater: 'Maybe Later',
  addedToMaybeLater: 'Added to Maybe Later',
  removeFromMaybeLater: 'Remove',

  learnMore: 'Learn More',

  'header.menu.recommendations': 'Skip to Recommendations',
  'header.menu.notes': 'Conversation Notes',
  'header.menu.start-over': 'Start Over',
  'header.menu.exit': 'End Session',

  'notes.title': 'Conversation Notes',

  'summary.nav.back': 'Return to Guide',
  'summary.cart.switchBtn': 'View Recommendations',
  'summary.recommendationsOne': 'Your Personalized',
  'summary.recommendationsTwo': 'Product Recommendations',
  'summary.financialHealthScore': 'Reloadable Visa® prepaid card is a smart way to control your money. Safer than cash, secure and easy to use.',
  'summary.financialHealthScoreUrl': '',
  'summary.financialHealthScoreButton': 'Get my Score',

  'products.disclosures': 'Disclosures',
  'products.addOns': 'Additional Products',
  'products.why': 'Why is this product for me?',

  'product.checking': 'Checking',
  'product.checkingAddOn': 'Checking',
  'product.saveInvest': 'Savings',
  'product.saveAddOn': 'Savings',
  'product.moneyMarketSavings': 'Savings',
  'product.certificateDeposit': 'Savings',
  'product.wealth': 'Wealth',
  'product.homeLoan': 'Loan & Lines',
  'product.homeEquity': 'Loan & Lines',
  'product.vehicle': 'Loan & Lines',
  'product.secured': 'Loan & Lines',
  'product.student': 'Loan & Lines',
  'product.creditCard': 'Credit',

  'productGroup.cart.openToday': 'Open Today with a Banker',
  'productGroup.cart.refer': 'Open with Your Team of Experts',
  'productGroup.cart.enroll': 'Enroll Today',
  'productGroup.cart.relationship': 'Your Relationship Benefits',
  'productGroup.cart.nextSteps': 'Learn More',
  'productGroup.cart.maybeLater': 'Maybe Later',

  'restartModal.title': 'Start Over',
  'restartModal.edit': 'Edit Answers',
  'restartModal.edit.details':
    'Return to the beginning of the guide so that you can change answers from this conversation',
  'restartModal.new': 'New Conversation',
  'restartModal.new.details': 'Start a clean conversation with the customer',
  'restartModal.button': '<i class="fa fa-angle-right"></i>',

  'shareViaEmail.title': 'Email Your Recommendations',
  'shareViaEmail.label': 'Enter your email address:',
  'shareViaEmail.button': 'Send',
  'shareViaEmail.success.title': 'Email Sent',
  'shareViaEmail.success.message': 'Your email has successfully been sent.',

  'appointment.title': 'Follow-up Appointment',
  'appointment.time': 'Time: ',
  'appointment.location': 'Location: ',
  'appointmentBooked.success.title': 'Appointment Booked',
  'appointmentBooked.success.message': 'Your appointment has successfully been booked.',

  'footer.bankerInfo': 'Created with assistance from: {name} at {branch}',
  'footer.recommendationInfo':
    'Your personal recommended solutions assessment number is #{ uuid } and was last updated ' +
    'on { date }.<br />Please refer to this number when you visit a branch or contact a banker over the phone so we can ' +
    'review your recommendations together.',
  'footer.address': '1900 5th Avenue North, Birmingham, AL 35203',
  'footer.disclaimer.1':
    'Each Regions account and all other Regions products and services are subject to terms and ' +
    'conditions, and may be subject to qualification requirements, credit approval and fees. Refer to the applicable ' +
    'agreement and any pricing schedule.',
  'footer.disclaimer.2':
    'Regions and the Regions logo are registered trademarks of Regions Bank. The LifeGreen color ' +
    'is a trademark of Regions Bank.',
  'footer.disclaimer.3':
    'This tool is provided by Regions Bank for educational purposes only and should not be ' +
    'construed as  financial advice or suggestion. The solutions recommended are based on your inputs. For details ' +
    'regarding additional features and fees, refer to the product guide.',
  'footer.disclaimer.4':
    '*Insurance products are offered through Regions Investment Services, Inc., an affiliate of ' +
    'Regions Bank. The purchase of insurance products through an affiliate is completely optional. Neither the ' +
    'purchase of insurance products through the bank or any of its affiliates, nor the agreement not to obtain, or a' +
    ' prohibition on the consumer from obtaining insurance products through an unaffiliated entity will affect any ' +
    'application for credit or the terms of any existing credit agreement with Regions Bank.',
  'footer.fdic.title': 'Investments, Annuities, and Insurance Products',
  'footer.fdic.1': 'Are Not FDIC Insured',
  'footer.fdic.2': 'Are Not Bank Guaranteed',
  'footer.fdic.3': 'May Lose Value',
  'footer.fdic.4': 'Are Not Deposits',
  'footer.fdic.5': 'Are Not Insured by Any Federal Government Agency',
  'footer.fdic.6': 'Are Not a Condition of Any Banking Activity',

  'footer.copyright': ' Regions Bank. 1900 5th Avenue North, Birmingham, AL 35203. All Rights Reserved.',
  'footer.header': 'Important Legal Disclosures and Information',
  'footer.disclosureTitle': 'Important Legal Disclosures and Information: ',
  'footer.disclosure': 'This tool is provided by Regions Bank for informational and general marketing purposes only and should not be construed as a recommendation or suggestion as to the advisability of acquiring, holding or disposing of a particular investment, nor should it be construed as a suggestion or indication that the particular investment or investment course of action described herein is appropriate for any specific investor. Investing in securities involves risks, and there is always the potential of losing money when you invest in securities. Past performance is no guarantee of future results. In providing this communication, Regions Bank is not undertaking to provide impartial investment advice or to give advice in a fiduciary capacity. Only bank deposit products are FDIC insured.  Annuities and Life Insurance are offered through Regions Investment Services, Inc. which is a wholly owned subsidiary of Regions Bank. Guarantee of insurance and/or annuities derives solely from financial status of the underwriting/issuing insurance company, which is not affiliated with Regions Bank. Regions Investment Solutions is a marketing name of Cetera Investment Services LLC. Securities and insurance products are offered through Cetera Investment Services, member FINRA/SIPC. Advisory services are offered through Cetera Investment Advisers LLC. Neither Cetera Investment Services nor, Cetera Investment Advisers is an affiliate of Regions Bank. Regions Investment Solutions, 250 Riverchase Parkway, Hoover, AL 35244 1-800-598-9164. The purchase of an insurance product through Regions Bank or any of its affiliate is completely optional.  Regions Bank may not condition an extension of credit or the provision of other services on either: 1) the purchase of an insurance product through Regions Bank or any of its affiliates, or 2) an agreement not to obtain or a prohibition on obtaining, an insurance product from an entity not affiliated with Regions Bank. All credit products are subject to terms and conditions, fees, documentation requirements, and credit approval.',
  'footer.trademarkShort': 'Regions, the Regions logo, and the LifeGreen bike are registered trademarks of Regions Bank. The LifeGreen color is a trademark of Regions Bank. NMLS #174490.',
  'footer.products': 'Investments, Annuities and Insurance Products',
  'footer.products.fdic': 'Are Not FDIC Insured',
  'footer.products.bank': 'Are Not Bank Guaranteed',
  'footer.products.value': 'May Lose Value',
  'footer.products.deposits': 'Are Not Deposits',
  'footer.products.insured': 'Are Not Insured by Any Federal Government Agency',
  'footer.products.condition': 'Are not a Condition of Any Banking Activity',

  'contactMe.title': 'Make an Appointment',
  'contactMe.subTitle': 'The information you provide to set up this appointment will not be used to update our records of your contact information. Regions may use this information and your responses to questions about your banking needs to extend offers or to recommend banking solutions to you in the future.',
  'contactMe.cancel': 'Cancel',
  'contactMe.continue': 'Continue',
  'contactMe.confirmAppointment': 'Confirm Appointment',
  'contactMe.close': 'Close',
  'contactMe.submit': 'Submit',
  'contactMe.firstName': 'First Name',
  'contactMe.firstName.placeholder': 'First Name',
  'contactMe.firstName.error': 'First Name is required',
  'contactMe.lastName': 'Last Name',
  'contactMe.lastName.placeholder': 'Last Name',
  'contactMe.lastName.error': 'Last Name is required',
  'contactMe.businessName': 'Business Name',
  'contactMe.businessName.placeholder': 'Business Name',
  'contactMe.businessName.error': 'Business Name is required',
  'contactMe.email': 'Email Address',
  'contactMe.email.placeholder': 'user@email.com',
  'contactMe.email.error': 'A valid email address is required',
  'contactMe.phone': 'Phone Number',
  'contactMe.phone.placeholder': '(555) 123-4567',
  'contactMe.phone.error': 'A valid 10-digit US phone number is required.',
  'contactMe.customerId': 'Customer Id Number',
  'contactMe.customerId.placeholder': 'Customer Id',
  'contactMe.customerId.error': 'A valid Customer Id is required',
  'contactMe.preferredTime': 'Preferred Time',
  'contactMe.preferredTime.placeholder': 'Please select',
  'contactMe.preferredTime.error': 'Please select',
  'contactMe.appointmentForm.zipCode': 'Zip Code',
  'contactMe.appointmentForm.zipCode.placeholder': 'Zip Code',
  'contactMe.appointmentForm.zipCode.error': 'A valid zip code is required',
  'contactMe.appointmentForm.thanksTitle': 'Thank you!',
  'contactMe.appointmentForm.thanksText': 'Your appointment is scheduled.',
  'contactMe.appointmentForm.completeText':
    'We are looking forward to meeting with you and providing solutions to ' + 'help grow your business.',
  'contactMe.appointmentForm.timeSelectMessage':
    "Select a time slot below and click 'Confirm' to complete your " + 'appointment booking.',
  'contactMe.appointmentForm.timeSelectError': 'You must select a time slot before you can continue.',
  'contactMe.appointmentForm.noLocations': 'No branch locations found for the zip code entered',
  'contactMe.appointmentForm.locationFormMessage': 'Please enter a zip code and select a location.',
  'contactMe.appointmentForm.locationError': 'You must select a location before you can continue.',
  'formInput.error.required': 'Required',
  'formInput.error.validate': 'Must be a valid phone number',

  'error.title': 'Errors',
  'error.question.required': 'Must be answered',
  'error.question.between': 'Value must be between {0} and {1}',
  'error.questionGroup.required': 'You must answer a question',
  'error.questionGroup.between': 'Total value must be between {0} and {1}',
  'error.questionGroup.equal': 'Total value must equal to {0}',

  'socialActions.email': 'Email',
  'socialActions.appointment': 'Appointment',
  'socialActions.print': 'Print',

  /**
   * ============================
   * CONSUMER PRODUCT MESSAGES
   * ============================
   */
  '1326.name': 'LifeGreen Preferred Checking®',
  '1326.description.abbreviated':
    'You want to earn interest and enjoy the added benefits that a deeper relationship with Regions can provide.',
  '1326.url': 'https://www.regions.com/personal-banking/open-checking-account-online/preferred-checking-account',
  '1326.features.count': 3,
  '1326.features.1': 'Based on your banking habits, you may qualify for a waiver of the monthly fee.',
  '1326.features.2': 'Enjoy earning interest.',
  '1326.features.3': 'No Regions ATM fee on two domestic ATM transactions at non-Regions ATMs per statement period and no fee for cashier’s checks and money orders.',
  '1326.disclosures.count': 0,
  '1326.url.quickGuide': 'https://www.regions.com/virtualDocuments/QuickGuide-PreferredChecking.pdf',

  '1324.name': 'LifeGreen® Checking for Students',
  '1324.description.abbreviated':
    "You're age 25 or younger and want the benefits of LifeGreen Checking without a monthly fee.",
  '1324.url': 'https://www.regions.com/personal-banking/open-checking-account-online/student-checking-account',
  '1324.features.count': 3,
  '1324.features.1': 'You are 25 or younger.',
  '1324.features.2': 'No monthly fee.',
  '1324.features.3': 'With this student checking account, you can get a <href>https://www.regions.com/personal_banking/lifegreen_savings.rf||Regions LifeGreen Savings Account.</href>',
  '1324.disclosures.count': 0,
  '1324.url.quickGuide': 'http://www.regions.com/virtualDocuments/QuickGuide-LifeGreenCheckingForStudents.pdf',

  '1325.name': 'LifeGreen® 62+ Checking',
  '1325.description.abbreviated':
    "You're age 62 or better and want LifeGreen Checking account benefits, plus easier options to waive the monthly account fee and bonus features.",
  '1325.url':
    'https://www.regions.com/personal-banking/open-checking-account-online/62-plus-retirement-checking-account',
  '1325.features.count': 3,
  '1325.features.1': 'Based on your banking habits, you may qualify for a waiver of the monthly fee.',
  '1325.features.2': 'Unlimited check writing.',
  '1325.features.3': 'With this retirement checking account, you can get a <href>https://www.regions.com/personal_banking/savings_cds.rf||Regions LifeGreen Savings Account</href>',
  '1325.disclosures.count': 0,
  '1325.url.quickGuide': 'https://www.regions.com/virtualDocuments/QuickGuide-62PlusLifeGreenChecking.pdf',

  '1321.name': 'LifeGreen® Checking',
  '1321.description.abbreviated':
    'By meeting simple direct deposit or balance requirements, you can get the monthly fee waived. Plus there is no check writing fee.',
  '1321.url': 'https://www.regions.com/personal-banking/open-checking-account-online/lifegreen-checking-account',
  '1321.features.count': 3,
  '1321.features.1': 'Based on your banking habits, you may qualify for a waiver of the monthly fee.',
  '1321.features.2': 'Unlimited check writing.',
  '1321.features.3': 'With this checking account, you can get a <href>https://www.regions.com/personal_banking/savings_cds.rf||Regions LifeGreen Savings Account</href>',
  '1321.disclosures.count': 0,
  '1321.url.quickGuide': 'https://www.regions.com/virtualDocuments/QuickGuide-LifegreenChecking.pdf',

  '1322.name': 'LifeGreen eAccess Account®',
  '1322.description.abbreviated':
    'You do most of your banking online and prefer using a card instead of writing checks to make purchases.',
  '1322.url': 'https://www.regions.com/personal-banking/open-checking-account-online/eaccess-checking-account',
  '1322.features.count': 3,
  '1322.features.1': 'You write few checks.',
  '1322.features.2': 'You like to bank when and how you want with Mobile Banking and Online Banking with Bill Pay.',
  '1322.disclosures.count': 0,
  '1322.url.quickGuide': 'https://www.regions.com/virtualDocuments/QuickGuide-eAccessAccount.pdf',

  '1323.name': 'LifeGreen Simple Checking℠',
  '1323.description.abbreviated': 'You prefer a simple approach to banking, without compromising on features.',
  '1323.url': 'https://www.regions.com/personal-banking/open-checking-account-online/simple-checking-account',
  '1323.features.count': 2,
  '1323.features.1': 'Peace of mind with a predictable monthly fee.',
  '1323.features.2': 'Don’t have to worry about special requirements like monthly balances or direct deposit.',
  '1323.disclosures.count': 0,
  '1323.url.quickGuide': 'https://www.regions.com/virtualDocuments/QuickGuide-SimpleChecking.pdf',

  '1351.name': 'Regions Now Card®',
  '1351.description.abbreviated': 'Your reloadable Visa® prepaid card is a smart way to control your money.',
  '1351.url': 'https://www.regions.com/personal_banking/now_banking.rf',
  '1351.features.count': 4,
  '1351.features.1': 'Can use almost everywhere Visa® Debit is accepted,',
  '1351.features.2': 'Safer than cash, secure and easy to use.',
  '1351.features.3': 'There are no costly overdraft fees.',
  '1351.features.4': 'Load the card at a <href>https://www.regions.com/locator.rf||Regions Branch</href>, <href>https:/www.regions.com/personal_banking/depositsmart_locations.rf||DepositSmart ATMs®</href>, with <href>https://www.regions.com/personal_banking/mobile_banking.rf||Mobile Deposit</href>, through <href>https://www.regions.com/personal_banking/regionsnet.rf||Online Banking</href> and any <href>http://usa.visa.com/locators/readylink-locations.jsp||Visa ReadyLink Location</href>. Load/fund fees may apply.',
  '1351.disclosures.count': 0,
  '1351.url.quickGuide': 'https://www.regions.com/virtualDocuments/QuickGuide-NowCard.pdf',

  '1334.name': 'Priority Banking®',
  '1334.description.abbreviated':
    'A preferred-customer program that delivers a high level of personal service along with special savings and earnings opportunities...all at no additional cost to you.',
  '1334.url': 'https://www.regions.com/personal_banking/priority_banking.rf',
  '1334.features.count': 3,
  '1334.features.1': 'Personal attention and expertise from your dedicated Priority Banker.',
  '1334.features.2': 'Fast, friendly assistance from the Regions Priority Banking Contact Center – with extended hours available seven days a week including bank holidays.',
  '1334.features.3': 'Special offers on select deposit and lending solutions targeted specifically to your needs.',
  '1334.disclosures.count': 0,
  '1334.url.additionalInfo': 'https://www.regions.com/personal_banking/priority_banking.rf',

  '1645.name': 'Regions LockIt℠',
  '1645.description.abbreviated':
    'This gives you the power to customize your Regions personal credit cards, CheckCards, prepaid Now cards and ATM cards to fit how, when and where you use them.',
  '1645.url': 'https://www.regions.com/promo/lockit-card-controls',
  '1645.features.count': 3,
  '1645.features.1': 'Access your Regions Mobile App¹ or through Online Banking',
  '1645.features.2': 'Simply lock the controls for the transactions you want to block, and unlock them as often as you’d like.',
  '1645.features.3': 'Peace of mind and control on all transactions, in-store purchases, online purchases and ATM transactions.',
  '1645.disclosures.count': 1,
  '1645.disclosures.1': "Your mobile carrier's message and data fees may apply.",

  '1646.name': 'Regions Relationship Rewards',
  '1646.description.abbreviated':
    'Earn Rewards for your everyday banking solutions and redeem them through the Relationship Rewards Catalog for cash, travel, merchandise, or gift cards.',
  '1646.url': 'https://www.regions.com/personal-banking/regions-rewards/relationship-rewards',
  '1646.features.count': 1,
  '1646.features.1': 'If you have a Regions Credit Card with Relationship Rewards you are automatically enrolled and you can earn points for purchases¹ made with your card.',
  '1646.disclosures.count': 1,
  '1646.disclosures.1': 'Points are not awarded for any purchases of items that can be traded right away for cash (such as wire transfers, money orders, traveler’s checks, lottery tickets or casino chips) or any other cash advances, balance transfers, fees, interest charges, or unauthorized or fraudulent purchases.',
  '1646.url.termsAndConditions': 'https://www.regions.com/-/media/pdfs/terms/Regions-Relationship-Rewards-Terms.pdf?revision=4aba4d31-f416-44cf-9bce-c9b83ce00906',

  '1648.name': 'Regions Cashback Rewards',
  '1648.description.abbreviated':
    'With the Regions Cashback Rewards program, you earn Regions Cashback Rewards® when you activate offers in Online or Mobile Banking and use your Visa® CheckCard or Now Card to make eligible purchases.',
  '1648.url': 'https://www.regions.com/personal-banking/regions-rewards/cashback-rewards',
  '1648.features.count': 3,
  '1648.features.1': 'Enroll - You are automatically enrolled in the Regions Cashback Rewards program if you have a Visa® CheckCard or Now Card and are enrolled in Regions Online Banking.',
  '1648.features.2': 'Shop - You’ll receive offers in Regions Online and Mobile Banking from participating retailers and service providers. Click on an offer to activate it, and use your Regions Visa® CheckCard or Now Card at the retailer or service provider to make purchases according to the terms of the offer.',
  '1648.features.3': 'Enjoy - The cash back you earn is automatically deposited in your checking account or added to your Now Card balance.',
  '1648.disclosures.count': 0,

  '1600.name': 'Regions Visa® CheckCard',
  '1600.description.abbreviated':
    'An easy, secure way to pay for gas, groceries, travel, online purchases, bills and more — right from your checking account — all within your control.',
  '1600.url': 'https://www.regions.com/personal_banking/platinum_visa_check.rf',
  '1600.features.count': 4,
  '1600.features.1': 'Use worldwide anywhere Visa is accepted — plus use it to get cash and for other ATM transactions.',
  '1600.features.2': 'With <href>https://yourpix.regions.com/||Regions YourPix Studio®</href> it only takes minutes to customize your card ($10 fee) ',
  '1600.features.3': "Comes with Visa's Zero Liability policy.",
  '1600.features.4': 'Use Click to Pay, Google Pay™, Apple Pay®, Samsung Pay®, or LG Pay™ for fast, easy ways to purchase.',
  '1600.disclosures.count': 1,
  '1600.disclosures.1': 'Visa Checkout is a trademark of Visa International Service Association.​ Apple Pay is a trademark of Apple Inc. Google Pay is a trademark of Google, Inc. Samsung Pay is a trademark of Samsung Electronics Co., Ltd. LG Pay is a trademark of LG Corp.',
  '1600.url.additionalInfo': 'https://www.regions.com/virtualdocuments/ATM_Debit_CheckCard_Agreement.pdf',

  '1601.name': 'Regions Online Banking',
  '1601.description.abbreviated':
    'Offers a simplified digital banking experience, designed for ease of navigation and provide the tools you need to manage your finances and access from anywhere.',
  '1601.url': 'https://www.regions.com/personal_banking/regions_digital_banking.rf',
  '1601.features.count': 3,
  '1601.features.1': 'Take advantage of a secure way to manage your finances online by checking your account balances and so much more.',
  '1601.features.2': 'Choose the convenience of online delivery for convenient access to your statements with Online Statements.',
  '1601.features.3': 'Powerful money management tools.',
  '1601.disclosures.count': 0,
  '1601.url.additionalInfo': 'https://www.regions.com/personal_banking/regions_digital_banking.rf',

  '1603.name': 'Regions Online Banking with Bill Pay',
  '1603.description.abbreviated':
    'Simplify your life with Bill Pay<sup>1</sup>, an easy, safe way to pay almost any merchant anywhere in the United States.',
  '1603.url': 'https://www.regions.com/personal_banking/regions_digital_banking.rf#paybills',
  '1603.features.count': 4,
  '1603.features.1': 'Take advantage of a secure way to manage your finances online by checking your account balances, paying bills and so much more.',
  '1603.features.2': 'Can make one-time, recurring or rush payments.',
  '1603.features.3': 'Can setup eBills and payment reminders.',
  '1603.features.4': 'Choose the convenience of online delivery for convenient access to your statements with Online Statements.',
  '1603.disclosures.count': 1,
  '1603.disclosures.1': 'You must be at least 18 years of age to use Regions Bill Pay.',
  '1603.url.additionalInfo': 'https://www.regions.com/personal_banking/regions_digital_banking.rf#paybills',

  '1604.name': 'Regions Mobile Banking with Mobile Deposit',
  '1604.description.abbreviated':
    'No matter how you choose to bank, we’re there with apps, mobile deposit, Zelle®, alerts, text banking and more, all on the go',
  '1604.url': 'https://www.regions.com/personal_banking/mobile_banking.rf',
  '1604.features.count': 4,
  '1604.features.1': 'Can receive up-to-date account information directly to your mobile device with mobile alerts. Your mobile carrier’s messaging and data fees may apply.',
  '1604.features.2': 'Can track your finances, pay bills and move money at your convenience.',
  '1604.features.3': 'Can deposit checks or load your Now Card (fee may apply) at your convenience.',
  '1604.features.4': 'Three funds availability options, including Available for Processing Tonight at no charge.',
  '1604.disclosures.count': 0,
  '1604.url.additionalInfo': 'https://www.regions.com/personal_banking/mobile_banking.rf',

  '1644.name': 'Zelle®',
  '1644.description.abbreviated':
    "Regions has partnered with Zelle®<sup>1</sup> to bring you a great way to send, request and receive money from people you know and trust - send money to a friend, settle up with your babysitter, or split the check for dinner.<br>If you don't know the person you are paying or aren't sure you'll get what you are purchasing, we recommend you do not use Zelle® for the transaction.",
  '1644.url': 'https://www.regions.com/digital-banking/send-money-with-zelle',
  '1644.features.count': 3,
  '1644.features.1': 'Safe: Move money between friends and family without sharing account information.',
  '1644.features.2': 'Easy: Log in to the Regions Mobile App or Regions Online Banking and choose “Send Money with Zelle®.”',
  '1644.features.3': 'Free: Zelle is free through the Regions Mobile App¹ and Regions Online Banking ',
  '1644.disclosures.count': 1,
  '1644.disclosures.1': "Zelle and the Zelle related marks are wholly owned by Early Warning Services, LLC and are used herein under license. Must have a bank account in the U.S. to use Zelle. Your mobile carrier's message and data fees may apply. You must be at least 18 years of age to use Zelle.",

  '1606.name': 'Regions Mobile Deposit',
  '1606.description.abbreviated':
    'Use the Regions Mobile App to deposit funds into your checking, savings, or money market accounts and load your Regions Now Card.',
  '1606.url': 'https://www.regions.com/personal_banking/mobile_banking.rf',
  '1606.disclosures.count': 0,

  '1607.name': 'Regions Personal Pay®',
  '1607.description.abbreviated':
    'A secure way to send money from your eligible Regions deposit account to anyone with a bank account in the United States.',
  '1607.url': 'https://www.regions.com/help/online-banking-help/make-payments',
  '1607.disclosures.count': 1,
  '1607.disclosures.1': 'The $1.00 fee will be charged to the sender at the time payment processing is initiated. The payment transaction amount that appears in your Online Banking transaction history statement will include the fee.',

  '1602.name': 'Regions My GreenInsights',
  '1602.description.abbreviated': 'A smart financial tool for smart money management.',
  '1602.url': 'https://www.regions.com/help/online-banking-help/budget-and-planning-tools',
  '1602.features.count': 3,
  '1602.features.1': 'Create budgets, set spending targets, and identify ways to save more money.',
  '1602.features.2': 'Track your income and upcoming bills.',
  '1602.features.3': 'Make managing your money enjoyable, educational, and effective.',
  '1602.disclosures.count': 0,
  '1602.url.additionalInfo': 'https://www.regions.com/help/online-banking-help/budget-and-planning-tools/general/how-do-i-start-using-my-greeninsights',

  '1609.name': 'Regions Financial Learning Center',
  '1609.description.abbreviated':
    '<a href="https://atwork.everfi.net/regions/login?utm_source=regionscom" target="_blank" rel="noopener nofollow">Free, online interactive videos on a variety of financial topics to help you confidently manage your money and move your life forward.',
  '1609.url': 'https://atwork.everfi.net/regions/login',
  '1609.features.count': 2,
  '1609.features.1': 'Increase your financial smarts in 10 minutes or less.',
  '1609.features.2': 'Learn more at your own pace across a variety of financial topics.',
  '1609.disclosures.count': 0,
  '1609.url.additionalInfo': 'https://www.regions.com/seminars/financial_learning_center.rf',

  '1335.name': 'Premium Money Market',
  '1335.description.abbreviated':
    'Enjoy the benefits of higher yield money market rates with the flexibility that allows you to have access to your money.',
  '1335.url': 'https://www.regions.com/personal_banking/relationship_money.rf',
  '1335.features.count': 3,
  '1335.features.1': 'Interest compounded daily, paid monthly on collected balance.',
  '1335.features.2': 'Offers limited check writing.',
  '1335.features.3': 'Transfer money between your Regions checking account and Regions Money Market without leaving home with Regions Online Banking and 1-800-REGIONS.',
  '1335.disclosures.count': 0,
  '1335.url.additionalInfo': 'https://www.regions.com/virtualDocuments/Checking-Pricing-Schedule.pdf',

  '1336.name': 'Regions Money Market',
  '1336.description.abbreviated': 'Earn money market rates with a small investment.',
  '1336.url': 'https://www.regions.com/personal_banking/money_market.rf',
  '1336.features.count': 3,
  '1336.features.1': 'Earn a competitive interest rate and still have easy access to your funds.',
  '1336.features.2': 'Interest compounded daily, paid monthly on collected balance.',
  '1336.features.3': 'Transfer money between your Regions checking account and Regions Money Market without leaving home with Regions Online Banking and 1-800-REGIONS.',
  '1336.disclosures.count': 0,
  '1336.url.additionalInfo': 'https://www.regions.com/virtualDocuments/Checking-Pricing-Schedule.pdf',

  '1337.name': 'Regions LifeGreen® Savings',
  '1337.description.abbreviated':
    'You’re looking for a simple way to put money aside and transfer funds from your Regions checking account.',
  '1337.url': 'https://www.regions.com/personal_banking/lifegreen_savings.rf',
  '1337.features.count': 3,
  '1337.features.1': 'Option to earn annual savings bonus on your savings balance.',
  '1337.features.2': 'Interest compounded daily, paid monthly on collected balance.',
  '1337.features.3': 'No minimum balance requirement and no monthly fee while Regions LifeGreen checking account is open.',
  '1337.disclosures.count': 0,
  '1337.url.additionalInfo': 'https://www.regions.com/virtualDocuments/Checking-Pricing-Schedule.pdf',

  '1338.name': 'Regions Savings',
  '1338.description.abbreviated':
    'Regions makes it easy to save with an automated savings plan. Set up monthly automated transfers from your checking account to your savings account.',
  '1338.url': 'https://www.regions.com/personal_banking/monthly_savings.rf',
  '1338.features.count': 3,
  '1338.features.1': 'Pay yourself first by setting up automatic transfers from your Regions checking account to Regions Savings.',
  '1338.features.2': 'Interest compounded daily, paid monthly on collected balance.',
  '1338.features.3': 'Transfer money between your Regions checking account and Regions Savings without leaving home with Regions Online Banking, Mobile Banking and 1-800-Regions.',
  '1338.disclosures.count': 0,
  '1338.url.additionalInfo': 'https://www.regions.com/virtualDocuments/Checking-Pricing-Schedule.pdf',

  '1339.name': 'Regions Now Savings®',
  '1339.description.abbreviated':
    'A Regions savings account with no monthly fee and no minimum balance requirement that allows customers to earn monthly and annual savings bonuses.',
  '1339.url': 'https://www.regions.com/personal_banking/now_savings.rf',
  '1339.features.count': 3,
  '1339.features.1': 'Exclusively for the primary account holder of a Regions Now Card.',
  '1339.features.2': 'Pays interest on all balances.',
  '1339.features.3': 'Convenient access through Regions® Online Banking or 1-800-REGIONS.',
  '1339.disclosures.count': 0,
  '1339.url.additionalInfo': 'https://www.regions.com/virtualdocuments/Now_Saving_Pricing_Schedule.pdf',

  '1362.name': 'Regions Promotional CD',
  '1362.description.abbreviated':
    'Lets you save money at a competitive rate for a fixed period of time, but does not allow deposits and withdrawals like a savings account.',
  '1362.url': 'https://www.regions.com/personal_banking/promotional_cd.rf',
  '1362.features.count': 3,
  '1362.features.1': 'Regions CDs can be automatically renewable. At maturity, the CD may renew for the same term automatically as the market rate at that time.',
  '1362.features.2': 'Easy account access through Regions Online Banking.',
  '1362.features.3': 'Security of FDIC Insurance coverage up to the maximum amount permitted by law.',
  '1362.disclosures.count': 0,
  '1362.url.additionalInfo': 'https://www.regions.com/virtualDocuments/Checking-Pricing-Schedule.pdf',

  '1352.name': 'Regions CD',
  '1352.description.abbreviated': 'Earn a competitive rate and predictable return.',
  '1352.url': 'https://www.regions.com/personal_banking/regular_cd.rf',
  '1352.features.count': 3,
  '1352.features.1': 'Regions CDs can be automatically renewable. At maturity, the CD may renew for the same term automatically as the market rate at that time.',
  '1352.features.2': 'Easy account access through Regions Online Banking.',
  '1352.features.3': 'Security of FDIC Insurance coverage up to the maximum amount permitted by law.',
  '1352.disclosures.count': 0,
  '1352.url.additionalInfo': 'https://www.regions.com/virtualDocuments/Checking-Pricing-Schedule.pdf',

  '1340.name': 'Regions Savings for Minors',
  '1340.description.abbreviated': "Special account for Regions customers' children or grandchildren.",
  '1340.url': 'https://www.regions.com/personal_banking/minor_savings.rf',
  '1340.features.count': 3,
  '1340.features.1': 'Help children and grandchildren begin to learn how to manage their money with a Regions savings account for children under 18 years of age.',
  '1340.features.2': 'Open this account with as little as $5.',
  '1340.features.3': 'Can be linked to a Regions checking account for an automated savings plan - funds can be transferred monthly, on paydays, or whenever you choose.',
  '1340.disclosures.count': 0,
  '1340.url.additionalInfo': 'https://www.regions.com/personal_banking/minor_savings.rf',

  '1629.name': 'Regions IRAs',
  '1629.description.abbreviated':
    'An IRA, or Individual Retirement Account, is a tax-advantaged investment account to save for retirement.  Regions offers a variety of IRA products.',
  '1629.url': 'https://www.regions.com/wealth_management/ira_solutions.rf',
  '1629.features.count': 3,
  '1629.features.1': 'No annual fee.',
  '1629.features.2': 'Pays interest on all balances.',
  '1629.features.3': 'Several options to meet your retirement needs.',
  '1629.disclosures.count': 0,

  '1630.name': 'Regions IRAs',
  '1630.description.abbreviated':
    'An IRA, or Individual Retirement Account, is a tax-advantaged investment account for individuals to save for retirement. Regions offers a variety of IRA products.',
  '1630.url': 'http://www.regions.com/wealth_management/ira_solutions.rf',
  '1630.features.count': 3,
  '1630.features.1': 'No annual fee.',
  '1630.features.2': 'Pays interest on all balances.',
  '1630.features.3': 'Several options to meet your retirement needs.',
  '1630.disclosures.count': 0,

  '1612.name': 'Fixed Annuities',
  '1612.description.abbreviated':
    'A fixed annuity is a unique insurance product provided by an insurance company that can be a great way to help save, provide the benefit of tax-deferred earnings and possibly guarantee income for life.',
  '1612.url': 'https://www.regions.com/personal_banking/annuity.rf',
  '1612.features.count': 3,
  '1612.features.1': 'Safe, fixed rate option backed by an insurance company.',
  '1612.features.2': 'Tax-deferred accumulation.',
  '1612.features.3': 'Guaranteed income payments.',
  '1612.disclosures.count': 1,
  '1612.disclosures.1': 'Annuity and Life Insurance products are offered through Regions Investment Services, Inc., a wholly owned subsidiary of Regions Bank, which is a subsidiary of Regions Financial Corporation.',
  '1612.footer': 'Investment, Insurance, and Annuity Products: are not FDIC insured, are not a deposit, may go down in value, are not bank guaranteed, are not insured by any government agency, are not a condition of any banking activity.',

  '1631.name': 'Licensed Banker Annuity Referral',
  '1631.description.abbreviated':
    'Regions Investment Solutions can provide the in-depth knowledge necessary to assist you in your financial goals.',
  '1631.url': 'https://www.regions.com/personal_banking/investment_services.rf',
  '1631.features.count': 1,
  '1631.features.1': 'When it comes to financial dreams, taking action is vital to success. Investors need to know where they are and where they want to go, but it’s not always easy. Our aim is to help investors get there. And we’re committed to help make the journey toward financial success as easy as possible.',
  '1631.disclosures.count': 2,
  '1631.disclosures.1': 'Regions Investment Solutions is a marketing name of Cetera Investment Services. Securities and insurance products are offered through Cetera Investment Services LLC, member FINRA/SIPC. Advisory services are offered through Cetera Investment Advisers LLC. Neither Cetera Investment Services nor Cetera Investment Advisers is an affiliate of Regions Bank or its related companies. Check the background of investment professionals on FINRA’s BrokerCheck. Financial Advisors are registered to conduct securities business and licensed to conduct insurance business in limited states. Response to, or contact with residents of other states will only be made upon compliance with applicable licensing and registration requirements. The information in this website is for U.S. residents only and does not constitute an offer to sell, or a solicitation of an offer to purchase brokerage services to persons outside of the United States.',
  '1631.disclosures.2': 'Regions Investment Services, Inc. is a wholly owned subsidiary of Regions Bank, which is a subsidiary of Regions Financial Corporation.',
  '1631.footer': 'Investment, Insurance, and Annuity Products: are not FDIC insured, are not a deposit, may go down in value, are not bank guaranteed, are not insured by any government agency, are not a condition of any banking activity.',

  '1632.name': 'Financial Advisor Referral',
  '1632.description.abbreviated':
    'Personalized investment solutions supported by an experienced Regions Investment Solutions Financial Advisor to design a customized investment strategy tailored to customers’ specific situations.',
  '1632.url': 'https://www.regions.com/personal_banking/investment_services.rf',
  '1632.features.count': 3,
  '1632.features.1': 'Supported by a team of subject-matter experts.',
  '1632.features.2': 'Powered by proven financial principles.',
  '1632.features.3': 'Guided by institutional experience and ethics.',
  '1632.disclosures.count': 2,
  '1632.disclosures.1': 'Annuity and Life Insurance products are offered through Regions Investment Services, Inc., a wholly owned subsidiary of Regions Bank, which is a subsidiary of Regions Financial Corporation.',
  '1632.disclosures.2': 'Regions Investment Solutions, 250 Riverchase Parkway East, Hoover, AL 35244, 800.598.9164. Regions Investment Solutions is a marketing name of Cetera Investment Services. Securities and insurance products are offered through Cetera Investment Services LLC, member FINRA/SIPC. Advisory services are offered through Cetera Investment Advisers LLC. Neither Cetera Investment Services nor Cetera Investment Advisers is an affiliate of Regions Bank.',

  '1359.name': 'Private Wealth Management',
  '1359.description.abbreviated':
    "A personalized financial strategy supported by an experienced team of professionals, all available through one Wealth Advisor – that's what you have with Regions Private Wealth Management.",
  '1359.url': 'https://www.regions.com/personal_banking/private_wealth_management.rf',
  '1359.features.count': 4,
  '1359.features.1': 'Supported by a team of subject-matter experts.',
  '1359.features.2': 'Powered by proven financial principles.',
  '1359.features.3': 'Guided by over a hundred years of institutional knowledge and experience.',
  '1359.features.4': 'Broader than just an investment plan.',
  '1359.disclosures.count': 0,

  '1618.name': 'How do I reach my savings goal?',
  '1618.url': 'https://www.regions.com/Insights/Personal/Savings-Calculators/how-do-i-reach-my-savings-goal',
  '1618.features.count': 0,
  '1618.disclosures.count': 0,

  '1619.name': 'How do I save for an emergency fund?',
  '1619.url': 'https://www.regions.com/Insights/Personal/Savings-Calculators/how-to-save-for-an-emergency-fund',
  '1619.features.count': 0,
  '1619.disclosures.count': 0,

  '1620.name': 'How much should I be saving for college?',
  '1620.url': 'https://www.regions.com/Insights/Personal/Savings-Calculators/how-much-should-i-be-saving-for-college',
  '1620.features.count': 0,
  '1620.disclosures.count': 0,

  '1621.name': 'How much should I save for retirement?',
  '1621.url': 'https://www.regions.com/Insights/Personal/Retirement-Calculators/how-much-should-i-save-for-retirement',
  '1621.features.count': 0,
  '1621.disclosures.count': 0,

  '1622.name': 'How much do I need to retire?',
  '1622.url': 'https://www.regions.com/Insights/Personal/Retirement-Calculators/how-much-should-i-save-for-retirement',
  '1622.features.count': 0,
  '1622.disclosures.count': 0,

  '1610.name': 'Mortgage Referral',
  '1610.description.abbreviated':
    "Mortgage Loan Originators can help you find the mortgage loan that's right for you with options available to assist you in buying a home, refinancing your current mortgage, or buying that vacation home retreat.",
  '1610.url': 'https://www.regions.com/mortgage/about.rf',
  '1610.features.count': 2,
  '1610.features.1': "Regions Mortgage is committed to serving the wide range of our customers' needs.",
  '1610.features.2': 'You can expect quality service and customer satisfaction from Regions Mortgage.',
  '1610.disclosures.count': 0,
  '1610.url.quickGuide': 'http://www.regions.com/virtualDocuments/QuickGuide-Mortgage.pdf',

  '1634.name': 'Mortgage Refinance Referral',
  '1634.description.abbreviated':
    "Mortgage Loan Originators can help you find the mortgage loan that's right for you with options available to assist you in buying a home, refinancing your current mortgage, or buying that vacation home retreat.",
  '1634.url': 'https://www.regions.com/mortgage/about.rf',
  '1634.features.count': 2,
  '1634.features.1': "Regions Mortgage is committed to serving the wide range of our customers' needs.",
  '1634.features.2': 'You can expect quality service and customer satisfaction from Regions Mortgage.',
  '1634.disclosures.count': 0,
  '1634.url.quickGuide': 'http://www.regions.com/virtualDocuments/QuickGuide-Mortgage.pdf',

  '1327.name': 'Regions Home Equity Line of Credit',
  '1327.description.abbreviated':
    'Line of credit secured by the equity in your home that allows funds to be borrowed, repaid and borrowed again. Funds can be used for various purposes like college expenses, home improvements, vacation, etc.',
  '1327.url': 'https://www.regions.com/personal_banking/equity_essentialine_info.rf',
  '1327.features.count': 3,
  '1327.features.1': 'Easy access to funds in a variety of methods.',
  '1327.features.2': 'Available all at once or in increments, right away or at a later date.',
  '1327.features.3': 'Option to convert balances into a fixed rate with the <href>https://www.regions.com/personal_banking/loan_in_a_line.rf||Loan in a Line</href> feature.',
  '1327.disclosures.count': 0,
  '1327.url.quickGuide': 'http://www.regions.com/virtualDocuments/QuickGuide-HELOC.pdf',

  '1328.name': 'Regions Home Equity Loan',
  '1328.description.abbreviated':
    'Loan secured by the equity in your home. Funds can be used for various purposes like college expenses, home improvements, vacation, etc.',
  '1328.url': 'https://www.regions.com/personal_banking/compare_line_loan.rf',
  '1328.features.count': 3,
  '1328.features.1': 'Competitive rates and fixed terms.',
  '1328.features.2': 'Closing costs will be paid by Regions.',
  '1328.features.3': 'Fixed rate over the life of your loan means no surprises and no loan payment increases.',
  '1328.disclosures.count': 0,
  '1328.url.quickGuide': 'http://www.regions.com/virtualDocuments/QuickGuide-HELOC.pdf',

  '1364.name': 'Regions Auto Loan',
  '1364.description.abbreviated':
    'This solution is right for you if you want to apply for a new, used or refinance auto loan. Three convenient ways to apply.',
  '1364.url': 'https://www.regions.com/personal_banking/auto_loans.rf',
  '1364.features.count': 2,
  '1364.features.1': 'Competitive rates and fixed terms.',
  '1364.features.2': 'Rate discounts available with automatic payments from a Regions checking account.',
  '1364.disclosures.count': 0,
  '1364.url.quickGuide': 'http://www.regions.com/virtualdocuments/QuickGuide-Installment-Loans.pdf',

  '1365.name': 'Regions Auto Loan Refinance',
  '1365.description.abbreviated':
    'For those who want to refinance a car loan. Process is entirely online at your convenience.',
  '1365.url': 'http://www.regions.com/personal_banking/auto_loans.rf',
  '1365.disclosures.count': 0,

  '1366.name': 'Regions Secured Installment Loan',
  '1366.description.abbreviated':
    'This solution is right for you if you need to make a major purchase, like a car or boat. Wide range of collateral options available.',
  '1366.url': 'https://www.regions.com/personal_banking/secured_loans_and_lines_of_credit.rf',
  '1366.features.count': 3,
  '1366.features.1': 'Low, fixed interest rates.',
  '1366.features.2': 'Purchase and refinance options available.',
  '1366.features.3': 'Funds are available in a single lump sum.',
  '1366.disclosures.count': 0,
  '1366.url.quickGuide': 'http://www.regions.com/virtualdocuments/QuickGuide-Installment-Loans.pdf',

  '1371.name': 'Regions Savings Secured Line of Credit',
  '1371.description.abbreviated':
    'Use your Savings Secured Line of Credit for minor home improvements, car repairs or vacations and borrow as little or as much as you need, up to your available credit limit.',
  '1371.url': 'https://www.regions.com/personal_banking/secured_loans_and_lines_of_credit.rf',
  '1371.features.count': 2,
  '1371.features.1': 'Secured by funds from your Regions savings account or money market account.  Credit limit is determined by your Regions savings account or money market account.',
  '1371.features.2': 'Your deposit account continues to earn interest although it is being used as security for your credit line and cannot be withdrawn.',
  '1371.disclosures.count': 2,
  '1371.disclosures.1': 'All loans are subject to terms and conditions, fees, documentation requirements, and credit approval.',
  '1371.disclosures.2': 'Receive a 0.25% interest rate reduction off the approved standard rate if you elect to have the payment automatically deducted from a Regions checking or savings account. Discount does not apply to loan amounts less than $5,000. Other discounts based upon your other Regions relationships may apply, talk to your Regions representative.',
  '1371.url.quickGuide': 'http://www.regions.com/virtualdocuments/QuickGuide-Savings-Secured-LOC.pdf',

  '1369.name': 'Regions Time Deposit (CD) Secured Loan',
  '1369.description.abbreviated':
    'For those who want to use their CD as collateral while avoiding penalties that would be incurred by the early withdrawal of CD funds.',
  '1369.url': 'https://www.regions.com/personal_banking/secured_loans_and_lines_of_credit.rf',
  '1369.disclosures.count': 0,

  '1370.name': 'Regions Savings Secured Loan',
  '1370.description.abbreviated':
    'This solution may be right for you if you want to use your savings as collateral while still maintaining a deposit account balance.',
  '1370.url': 'https://www.regions.com/personal_banking/secured_loans_and_lines_of_credit.rf',
  '1370.features.count': 3,
  '1370.features.1': 'Can use the money for multiple purposes.',
  '1370.features.2': 'Predictable monthly payments and low interest rates.',
  '1370.features.3': 'Funds are available immediately at closing.',
  '1370.disclosures.count': 0,
  '1370.url.quickGuide': 'http://www.regions.com/virtualDocuments/QuickGuide-DepositSecured.pdf',

  '1332.name': 'Regions Preferred Line of Credit',
  '1332.description.abbreviated':
    'This solution may be right for you if you want easy access to funds for home improvement projects, vacation or unplanned expenses.',
  '1332.url': 'https://www.regions.com/personal_banking/unsecured_loans_and_lines_of_credit.rf',
  '1332.features.count': 3,
  '1332.features.1': 'Easy access to funds in a variety of methods.',
  '1332.features.2': 'Can use the money for multiple purposes.',
  '1332.features.3': 'Borrow as little or as much as you need up to your available credit limit.',
  '1332.disclosures.count': 0,
  '1332.url.quickGuide': 'http://www.regions.com/virtualDocuments/QuickGuide-Preferred-LOC.pdf',

  '1367.name': 'Regions Credit Line',
  '1367.description.abbreviated':
    'This solution may be right for you if you want easy access to funds when you need it. Ideal for overdraft protection.',
  '1367.url': 'https://www.regions.com/personal_banking/unsecured_loans_and_lines_of_credit.rf',
  '1367.features.count': 2,
  '1367.features.1': 'Can use to fund emergency needs',
  '1367.features.2': 'Borrow as little or as much as you need up to your available credit limit.',
  '1367.disclosures.count': 0,
  '1367.url.quickGuide': 'http://www.regions.com/virtualDocuments/QuickGuide-CreditLine.pdf',

  '1368.name': 'Regions Personal Unsecured Loan',
  '1368.description.abbreviated':
    'Our Quickest Loan Ever. Designed Just for You. This unsecured loan can bridge the gap between where you are and where you want to be.',
  '1368.url':
    'https://www.regions.com/personal-banking/personal-loans/personal-unsecured-loan?WT.ac=Avant-CTA-LearnMore-TopPersonalLoansPage',
  '1368.features.count': 4,
  '1368.features.1': 'No collateral required.',
  '1368.features.2': 'Borrow up to $50,000 in a branch or over the phone and up to $35,000 online.',
  '1368.features.3': 'Fixed interest rate with predictable monthly payments.',
  '1368.features.4': 'Regions deposit account customers who are approved could have the funds electronically deposited as fast as the same day depending upon the time of your approval.',
  '1368.features.4.rule': 'isCurrentCustomer == true',
  '1368.disclosures.count': 2,
  '1368.disclosures.1': 'All loans are subject to terms and conditions, fees, documentation requirements, and credit approval.',
  '1368.disclosures.2': 'Receive a 0.25% interest rate reduction off the approved standard rate if you elect to have the payment automatically deducted from a Regions checking or savings account. Discount does not apply to loan amounts less than $5,000. Other discounts based upon your other Regions relationships may apply, talk to your Regions representative.',
  '1368.url.quickGuide': 'http://www.regions.com/virtualdocuments/QuickGuide-Installment-Loans.pdf',

  '1431.name': 'Regions Premium℠ Visa® Signature Credit Card',
  '1431.description.abbreviated':
    'This solution is right for you if you want exceptional benefits and the optional Relationship Rewards® program.',
  '1431.url': 'https://www.regions.com/personal_banking/premium_credit_card.rf',
  '1431.disclosures.count': 0,

  '1433.name': 'Regions Prestige℠ Visa® Signature Credit Card',
  '1433.description.abbreviated':
    'Visa® Signature Credit Card earns Relationship Rewards® points on qualifying purchases that can be redeemed for 1% cash, travel or merchandise, and includes Purchase Security, Lost Luggage Reimbursement and Visa Signature Concierge.',
  '1433.url': 'https://www.regions.com/personal-banking/credit-cards/prestige-credit-card',
  '1433.features.count': 3,
  '1433.features.1': "Manage your credit card account online, and bank when you want with Mobile Banking, Online Banking with Bill Pay, and access to over 1,900 ATMs across Regions' 15-state service area.",
  '1433.features.2': 'Enjoy the convenience and security of using Google Pay™, Apple Pay®, Samsung Pay® and LG Pay®.¹',
  '1433.features.3': 'Reduce the risk of fraud on your Regions cards, use Regions <href>https://www.regions.com/promo/lockit-card-controls||LockIt℠</href>: with the touch of a button, block ATM, in-store and/or online transactions with your Regions mobile app.',
  '1433.disclosures.count': 1,
  '1433.disclosures.1': 'Apple Pay is a trademark of Apple Inc. Google Pay is a trademark of Google, Inc. Samsung Pay is a trademark of Samsung Electronics Co., Ltd. LG Pay is a trademark of LG Corp.',
  '1433.url.quickGuide': 'https://www.regions.com/virtualdocuments/QuickGuide-PersonalCreditCard.pdf',

  '1434.name': 'Regions Life℠ Visa® Credit Card',
  '1434.description.abbreviated':
    'Visa credit card with a lower rate perfect for those who plan to carry a balance, need financing options for unexpected expenses or for making everyday purchases.',
  '1434.url': 'https://www.regions.com/personal-banking/credit-cards/life-credit-card',
  '1434.features.count': 2,
  '1434.features.1': 'Use instead of cash for everyday purchases like gas and groceries to manage your finances.',
  '1434.features.2': 'Convenience of managing and paying your credit card online.',
  '1434.disclosures.count': 0,
  '1434.url.quickGuide': 'https://www.regions.com/virtualdocuments/QuickGuide-PersonalCreditCard.pdf',

  '1613.name': 'Regions Explore℠ Visa® Credit Card',
  '1613.description.abbreviated':
    'Visa credit card secured by funds in a Regions Explore Card Savings account and may be an option for consumers who would not qualify for an unsecured credit card.',
  '1613.url.count': '2',
  '1613.url.1': 'https://www.regions.com/personal-banking/credit-cards/explore-card',
  '1613.url.1.rule': '!hasAnsweredWith("bankingRelationship", {"no"})',
  '1613.url.1.ctaText': 'Apply Now',
  '1613.url.2': 'tel:1-888-462-7627',
  '1613.url.2.rule': 'hasAnsweredWith("bankingRelationship", {"no"})',
  '1613.url.2.ctaText': 'Call 1-888-462-7627, option 3',
  '1613.features.count': 3,
  '1613.features.1': 'Acceptance and security of using a Visa credit card with chip technology.',
  '1613.features.2': 'Can help to build positive credit history through responsible use.',
  '1613.features.3': 'Convenience of managing and paying your credit card online.',
  '1613.disclosures.count': 0,
  '1613.url.quickGuide': 'https://www.regions.com/virtualdocuments/QuickGuide-PersonalCreditCard.pdf',

  '1623.name': 'Are credit card balance transfers worth it?',
  '1623.url': 'https://www.regions.com/Insights/Personal/Debt-Calculators/are-credit-card-balance-transfers-worth-it',
  '1623.features.count': 0,
  '1623.disclosures.count': 0,

  '1624.name': 'How to consolidate debt?',
  '1624.url': 'https://www.regions.com/Insights/Personal/Debt-Calculators/how-to-consolidate-debt',
  '1624.features.count': 0,
  '1624.disclosures.count': 0,

  '1625.name': 'Should I use a home equity loan for debt consolidation?',
  '1625.url':
    'https://www.regions.com/Insights/Personal/Home-Equity-Calculators/should-i-use-a-home-equity-loan-for-debt-consolidation',
  '1625.features.count': 0,
  '1625.disclosures.count': 0,

  '1627.name': 'Should I refinance my mortgage?',
  '1627.url': 'https://www.regions.com/Insights/Personal/Mortgage-Calculators/should-i-refinance-my-mortgage',
  '1627.features.count': 0,
  '1627.disclosures.count': 0,

  '1628.name': 'Calculate my car payment.',
  '1628.url': 'https://www.regions.com/Insights/Personal/Auto-Calculators/how-much-will-my-car-payment-be',
  '1628.features.count': 0,
  '1628.disclosures.count': 0,

  '1642.name': 'How do I compare mortgage loans?',
  '1642.url': 'https://www.regions.com/Insights/Personal/Mortgage-Calculators/how-do-i-compare-mortgage-loans',
  '1642.features.count': 0,
  '1642.disclosures.count': 0,

  '1643.name': 'How much home can I afford?',
  '1643.url': 'https://www.regions.com/Insights/Personal/Mortgage-Calculators/how-much-home-can-i-afford',
  '1643.features.count': 0,
  '1643.disclosures.count': 0,

  '1360.name': 'Regions Overdraft Protection',
  '1360.description.abbreviated':
    'This solution is right for you if you want to link your Regions checking account to a designated Regions funding account for overdraft protection.',
  '1360.url': 'https://www.regions.com/personal_banking/overdraft_protection.rf',
  '1360.features.count': 2,
  '1360.features.1': 'Give you peace of mind.',
  '1360.features.2': 'Life is busy, your banking should be easy.',
  '1360.disclosures.count': 0,

  '1608.name': 'Regions Safe Deposit Box',
  '1608.description.abbreviated':
    'This solution may be right for you if you want a way to secure and protect vital family documents and heirlooms.',
  '1608.url': 'https://www.regions.com/personal_banking/safe_deposit_box.rf',
  '1608.features.count': 2,
  '1608.features.1': 'Peace of mind.',
  '1608.features.2': "Protect your valuables from life's unexpected events.",
  '1608.disclosures.count': 0,

  '1611.name': 'Life Insurance',
  '1611.description.abbreviated':
    'Through our licensed bankers, Regions Investment Services offers a wide range of life insurance products which are safe, secure and guaranteed by an insurance company.',
  '1611.url': 'https://www.regions.com/personal_banking/life_insurance.rf',
  '1611.features.count': 4,
  '1611.features.1': 'Planning for unexpected events – death of a spouse, loved one.',
  '1611.features.2': 'Helps plan to keep a family’s lifestyle and goals in tact in the event of unforeseen/premature death of a provider.',
  '1611.features.3': 'Helping a company plan to keep the business in tact in the event of their Key Person’s death.',
  '1611.features.4': 'Safe, secure and guaranteed by an insurance company.',
  '1611.disclosures.count': 1,
  '1611.disclosures.1': 'Annuity and Life Insurance products are offered through Regions Investment Services, Inc., a wholly owned subsidiary of Regions Bank, which is a subsidiary of Regions Financial Corporation.',
  '1611.footer': 'Investment, Insurance, and Annuity Products: are not FDIC insured, are not a deposit, may go down in value, are not bank guaranteed, are not insured by any government agency, are not a condition of any banking activity.',

  '1617.name': 'Licensed Banker Life Insurance Referral',
  '1617.description.abbreviated':
    'Regions Investment Services can provide the in-depth knowledge necessary to assist you in your financial goals.',
  '1617.url': 'https://www.regions.com/personal_banking/investment_services.rf',
  '1617.features.count': 2,
  '1617.features.1': 'When it comes to financial dreams, taking action is vital to success. Investors need to know where they are and where they want to go, but it’s not always easy. Our aim is to help investors get there. And we’re committed to help make the journey toward financial success as easy as possible.',
  '1617.features.2': "Regions Investment Solutions can provide the in-depth knowledge necessary to assist. Whatever an investor's stage in life, we can help.",
  '1617.disclosures.count': 2,
  '1617.disclosures.1': 'Regions Investment Solutions is a marketing name of Cetera Investment Services. Securities and insurance products are offered through Cetera Investment Services LLC, member FINRA/SIPC. Advisory services are offered through Cetera Investment Advisers LLC. Neither Cetera Investment Services nor Cetera Investment Advisers is an affiliate of Regions Bank or its related companies. Check the background of investment professionals on FINRA’s BrokerCheck. Financial Advisors are registered to conduct securities business and licensed to conduct insurance business in limited states. Response to, or contact with residents of other states will only be made upon compliance with applicable licensing and registration requirements. The information in this website is for U.S. residents only and does not constitute an offer to sell, or a solicitation of an offer to purchase brokerage services to persons outside of the United States.',
  '1617.disclosures.2': 'Regions Investment Services, Inc. is a wholly owned subsidiary of Regions Bank, which is a subsidiary of Regions Financial Corporation.',
  '1617.footer': 'Investment, Insurance, and Annuity Products: are not FDIC insured, are not a deposit, may go down in value, are not bank guaranteed, are not insured by any government agency, are not a condition of any banking activity.',

  '1458.name': 'Regions Cash Rewards Visa® Signature',
  '1458.description.abbreviated':
    'Turn everyday spending into something more rewarding. The Regions Cash Rewards Visa® Signature Credit Card earns 1.5% Cash Rewards on qualifying purchases with no limits to the amount of Cash Rewards you can earn.',
  '1458.url': 'https://www.regions.com/personal-banking/credit-cards/cash-rewards-card',
  '1458.features.count': 3,
  '1458.features.1': "Manage your credit card account online, and bank when you want with Mobile Banking, Online Banking with Bill Pay, and access to over 1,900 ATMs across Regions' 15-state service area.",
  '1458.features.2': 'Enjoy the convenience and security of using Google Pay™, Apple Pay®, Samsung Pay® and LG Pay®.¹',
  '1458.features.3': 'Reduce the risk of fraud on your Regions cards, use Regions <href>https://www.regions.com/promo/lockit-card-controls||LockIt℠</href>: with the touch of a button, block ATM, in-store and/or online transactions with your Regions mobile app.',
  '1458.disclosures.count': 1,
  '1458.disclosures.1': 'Apple Pay is a trademark of Apple Inc. Google Pay is a trademark of Google, Inc. Samsung Pay is a trademark of Samsung Electronics Co., Ltd. LG Pay is a trademark of LG Corp.',
  '1458.url.quickGuide': 'https://www.regions.com/virtualdocuments/QuickGuide-PersonalCreditCard.pdf',

  /**
   * ============================
   * BUSINESS PRODUCT MESSAGES
   * ============================
   */

  /**
   * Business Checking Products [EVERYDAY BANKING]
   */

  '1451.name': 'Advantage Business Checking',
  '1451.url': 'https://www.regions.com/small-business/business-checking/advantage-business-checking',
  '1451.url.quickGuide': 'http://www.regions.com/virtualDocuments/QuickGuide-Advantage-Business-Checking.pdf ',
  '1451.url.pricing': pricing,
  '1451.url.deposit': deposit,
  '1451.description.abbreviated':
    'You are a small business owner, have a moderate monthly transaction volume and you ' +
    'use, or want to use, multiple Regions business accounts and services.',
  '1451.description':
    'The monthly fee can be waived by maintaining qualifying average monthly checking balance or ' +
    'qualifying balances in other Regions deposit or loan accounts.<sup>1</sup> Plus, the monthly fee may be waived ' +
    'with qualifying purchases using a Regions Visa Business CheckCard or Credit Card, Regions Merchant Services, or ' +
    'Regions Quick Deposit. This account provides 500 transactions each statement period at no charge. Key benefits ' +
    'include Regions Online Banking with Bill Pay for Business and Mobile Banking, My GreenInsights for Business, ' +
    'Regions Business Visa CheckCard with optional Cashback Rewards.',
  '1451.features.count': 2,
  '1451.features.1': 'Moderate monthly transactions ',
  '1451.features.2':
    'Choice of Regions iTreasury Small Business cash management package OR Regions Online Banking ' +
    'for Business with Bill Pay',
  '1451.disclosures.count': 1,
  '1451.disclosures.1': fees,

  '1452.name': 'LifeGreen Business Checking',
  '1452.url': 'https://www.regions.com/small-business/business-checking/lifegreen-business-checking',
  '1452.url.quickGuide': 'https://www.regions.com/virtualDocuments/QuickGuide_LG_Business_Checking.pdf ',
  '1452.url.pricing': pricing,
  '1452.url.deposit': deposit,
  '1452.description.abbreviated':
    'You are a business owner with a sole proprietorship, startup or LLC, and you want ' +
    'a checking account with convenient e-services.',
  '1452.description':
    'The monthly fee can be waived with one of the following: by maintaining a qualifying average ' +
    'monthly balance or with qualifying purchases using a Regions Visa Business CheckCard or Credit Card, or with ' +
    'Regions Merchant Services.<sup>1</sup> This account provides 150 transactions at no charge. Key benefits include ' +
    'Regions Online Banking with Bill Pay for Business and Mobile Banking, My GreenInsights for Business, Regions ' +
    'Business Visa CheckCard with optional Cashback Rewards.',
  '1452.features.count': 2,
  '1452.features.1': 'You typically process less than 150 paper checks and electronic items each',
  '1452.features.2':
    'Choice of Regions iTreasury Small Business cash management package OR Regions Online Banking ' +
    'for Business with Bill Pay',
  '1452.disclosures.count': 1,
  '1452.disclosures.1': fees,

  '1453.name': 'LifeGreen Business Simple Checking',
  '1453.url': 'https://www.regions.com/small-business/business-checking/lifegreen-business-simple-checking',
  '1453.url.quickGuide': 'http://www.regions.com/virtualdocuments/QuickGuide_Business_Simple_Checking.pdf ',
  '1453.url.pricing': pricing,
  '1453.url.deposit': deposit,
  '1453.description.abbreviated':
    'Checking account for small business owners who have limited transaction needs,' +
    ' use a CheckCard or credit card frequently, and don’t want to be restricted by minimum balance requirements.',
  '1453.description':
    'The low monthly fee can be waived with qualifying purchases using a Regions Visa Business ' +
    'CheckCard or Credit Card.<sup>1</sup> This account provides 75 transactions at no charge. Key benefits include ' +
    'Regions Online Banking with Bill Pay for Business and Mobile Banking, My GreenInsights for Business, Regions ' +
    'Business Visa CheckCard with optional Cashback Rewards.',
  '1453.features.count': 3,
  '1453.features.1': 'No minimum checking balance requirement',
  '1453.features.2': 'Your business has limited monthly transactions',
  '1453.features.3': 'Offers convenient e-services to simplify everyday banking needs',
  '1453.disclosures.count': 1,
  '1453.disclosures.1': fees,

  '1455.name': 'LifeGreen Not-for-Profit Checking',
  '1455.url': 'https://www.regions.com/small-business/business-checking/lifegreen-not-for-profit-checking',
  '1455.url.quickGuide': 'http://www.regions.com/virtualDocuments/QuickGuide-Not-for-Profit-Checking.pdf ',
  '1455.url.pricing': pricing,
  '1455.url.deposit': deposit,
  '1455.description.abbreviated':
    'Our LifeGreen Not-for-Profit Checking Account is the ideal no monthly fee ' +
    'business checking account for owners of non-profit organizations with low transaction volume.',
  '1455.description':
    'No monthly fee for non-profit organizations. This account provides you the first 75 ' +
    'transactions at no charge.<sup>1</sup> Key benefits include Regions Online Banking with Bill Pay and Regions ' +
    'Mobile Deposit for Business, My GreenInsights, Business Visa CheckCard with Cashback Rewards.',
  '1455.features.count': 3,
  '1455.features.1': 'Not for profit businesses qualify for a monthly fee waiver',
  '1455.features.2': 'Your business has limited monthly transactions',
  '1455.features.3': 'Offers convenient e-services to simplify everyday banking needs',
  '1455.disclosures.count': 1,
  '1455.disclosures.1': fees,

  '1454.name': 'Business Interest Checking',
  '1454.url': 'https://www.regions.com/small-business/business-checking/business-interest-checking',
  '1454.url.quickGuide': 'http://www.regions.com/virtualDocuments/QuickGuide-Not-for-Profit-Checking.pdf ',
  '1454.url.pricing': pricing,
  '1454.url.deposit': deposit,
  '1454.description.abbreviated':
    'You own a company and need a flexible small business checking account that enables ' +
    'you to earn a competitive interest rate, and offer group banking services to your employees.',
  '1454.description':
    'For businesses who want to earn a competitive interest rate without check writing limits' +
    '<sup>1</sup>. This account provides the first 150 transactions at no charge, web access to account management ' +
    'through Regions Business Online or Regions Business Online cash management package<sup>2</sup>, discounts on ' +
    'safe deposit box rental, a no-annual fee Regions Visa® Business Credit Card<sup>3</sup> and mobile banking.',
  '1454.features.count': 3,
  '1454.features.1':
    'Choice of Regions iTreasury Small Business ' +
    '<a href="https://www.regions.com/commercial_banking/treasury_manage.rf" target="_blank" rel="noopener noreferrer">' +
    'cash management package</a> OR, <a href="https://www.regions.com/personal_banking/regions_digital_banking.rf" ' +
    'target="_blank" rel="noopener noreferrer">Regions Online Banking for Business</a> with ' +
    '<a href="https://www.regions.com/personal_banking/regions_digital_banking.rf#paybills" target="_blank">Bill Pay</a>',
  '1454.features.2': "Maintain a monthly average balance of $5,000. Otherwise, there's a monthly fee of $15.",
  '1454.features.3': 'No charge for the first 150 items each statement period; then $0.50 for each additional item',
  '1454.disclosures.count': 0,

  /**
   * Business Savings Products [SAVINGS PLANS]
   */

  '1641.name': 'Business Premium Money Market',
  '1641.url': 'https://www.regions.com/small_business/bus_money_market.rf',
  '1641.url.pricing': pricing,
  '1641.url.deposit': deposit,
  '1641.description.abbreviated':
    'A Business Premium Money Market allows you to earn money at market rates plus ' +
    'convenient account access with limited check writing and preauthorized transfers for your business.',
  '1641.description':
    'With a Regions Money Market account you earn a competitive interest rate on your savings ' +
    'while maintaining access to your funds.1 The monthly fee may be waived with a minimum daily balance of $5,000.',
  '1641.features.count': 3,
  '1641.features.1':
    'Interest compounded daily, paid monthly on funds in your account for which Regions has received credit',
  '1641.features.2': 'Can set up automated transfers from a Regions Checking account',
  '1641.features.3': 'Can be linked to a Regions Checking account for Overdraft Protection<sup>1</sup>',
  '1641.disclosures.count': 1,
  '1641.disclosures.1':
    'Regulatory limit of six (6) transfers or payments (preauthorized, automatic, by telephone, ' +
    'or from a personal computer), including drafts, checks, debit card, or similar orders (including POS transactions ' +
    'and Overdraft Protection transfers) payable to a third party or another account owned by you, from your savings ' +
    'or money market account per statement period. The preauthorized or automatic transactions may be initiated by ' +
    'Telephone Banking, Regions Online Banking, or standing order. Limit does not apply to in-person withdrawals or ' +
    'withdrawals at an ATM. Exceeding the regulatory limit on transfers and withdrawals on more than an occasional ' +
    'basis may result in your savings or money market account being converted to a transaction account.',

  '1635.name': 'Business Savings Account',
  '1635.url': 'https://www.regions.com/small_business/business_savings.rf',
  '1635.url.pricing': pricing,
  '1635.url.deposit': deposit,
  '1635.description.abbreviated':
    'A business savings account with access to funds and the ability for business to earn interest.',
  '1635.description':
    'The low monthly fee may be waived with a minimum daily balance of $500. Earn interest on your ' +
    'savings while retaining access to funds.<sup>1</sup>',
  '1635.features.count': 3,
  '1635.features.1':
    'Interest compounded daily, paid monthly on funds in your account for which Regions has received credit',
  '1635.features.2': 'Can set up automated transfers from a Regions Checking account',
  '1635.features.3': 'Can be linked to a Regions Checking account for Overdraft Protection',
  '1635.disclosures.count': 1,
  '1635.disclosures.1':
    'Regulatory limit of six (6) transfers or payments (preauthorized, automatic, by telephone, ' +
    'or from a personal computer), including drafts, checks, debit card, or similar orders (including POS transactions ' +
    'and Overdraft Protection transfers) payable to a third party or another account owned by you, from your savings ' +
    'or money market account per statement period. The preauthorized or automatic transactions may be initiated by ' +
    'Telephone Banking, Regions Online Banking, or standing order. Limit does not apply to in-person withdrawals or ' +
    'withdrawals at an ATM. Exceeding the regulatory limit on transfers and withdrawals on more than an occasional ' +
    'basis may result in your savings or money market account being converted to a transaction account.',
  '1649.name': 'Business Certificate of Deposit',
  '1649.url': 'https://www.regions.com/small_business/regular_business_cds.rf',
  '1649.url.pricing': pricing,
  '1649.url.deposit': deposit,
  '1649.description.abbreviated':
    'Knowing that no two customers have the same future plans or current life ' +
    'circumstances, Regions offers a variety of Business CD plans.',
  '1649.description':
    'CDs let you save money at a competitive rate for a fixed period of time, but do not allow ' +
    'deposits and withdrawals like a savings account.',
  '1649.features.count': 3,
  '1649.features.1':
    'Interest is compounded daily and paid according to the terms on the CD:  Monthly, quarterly, ' +
    'semi-annually, annually or at maturity.',
  '1649.features.2':
    'Regions CDs can be automatically renewable. At maturity, the CD may renew for the same term ' +
    'automatically at the market rate at that time.',
  '1649.features.3': 'Access your account 24 hours a day, 7 days a week through Regions Online Banking.',
  '1649.disclosures.count': 0,

  /**
   * Business Checking Add-ons [RELATIONSHIP BENEFITS]
   */
  '1633.name': 'Refer a Friend',
  '1633.url': 'https://www.regions.com/refer',
  '1633.description.abbreviated':
    'Refer a friend to Regions and get a $50 Visa® Reward Card when you refer a friend ' +
    'that opens a new Regions personal LifeGreen® checking account or business checking account and fulfills all ' +
    'requirements of the offer.',
  '1633.description':
    'Refer a friend to Regions and get a $50 Visa® Reward Card when you refer a friend that opens a ' +
    'new Regions personal LifeGreen® checking account or business checking account and fulfills all requirements of the offer.',
  '1633.features.count': 3,
  '1633.features.1': 'Refer a friend to Regions and get a $50 Visa® Reward Card for each completed referral.',
  '1633.features.2': 'Refer up to ten (10) individuals or businesses per calendar year.',
  '1633.features.3': 'The referred person or business is also eligible for a Reward Card.',
  '1633.disclosures.count': 0,
  '1633.url.additionalInfo': 'https://www.regions.com/promo/refer-a-friend-terms',

  '1687.name': 'Next Step Seminars (Financial Wellness)',
  '1687.url': 'https://www.regions.com/seminars/financial_fundamentals.rf',
  '1687.description.abbreviated':
    'Next Step is a workplace financial wellness program that inspires and equips ' +
    'employees in our business communities with personalized financial guidance, advice and tools. Next Step: will ' +
    'help both existing and potential bank clients break down any financial goal into manageable and achievable steps ' +
    'so they can focus on excelling at work and relaxing in life.',
  '1687.description':
    'Next Step is a workplace financial wellness program that inspires and equips employees in our ' +
    'business communities with personalized financial guidance, advice and tools. Next Step: will help both existing ' +
    'and potential bank clients break down any financial goal into manageable and achievable steps so they can focus ' +
    'on excelling at work and relaxing in life.',
  '1687.features.count': 3,
  '1687.features.1':
    'Financial issues are the number one cause of employee stress in the workplace leading to a loss ' +
    'of productivity and ultimately loss of revenue to the business',
  '1687.features.2':
    'Offers employees the tools and resources to help strengthen their financial lives through ' +
    'customizable seminars and digital tools',
  '1687.features.3':
    'Program is at no cost to the business with a focus on providing guidance and perspective to all employees',
  '1687.disclosures.count': 0,

  '1650.name': 'Business CheckCard',
  '1650.url': 'https://www.regions.com/personal-banking/debit-gift-cards/business-checkcard',
  '1650.description.abbreviated':
    'Can be used to pay by choosing either debit or credit, and provides an easy and ' +
    'convenient way to pay and keep track of funds spent on gas, office supplies, entertainment and other business expenses.',
  '1650.description':
    'You have a Regions business checking account and want a convenient way to pay for office ' +
    'supplies, gas, travel and entertainment, and other business expenses.',
  '1650.features.count': 3,
  '1650.features.1':
    'Convenient way to pay; Easily add your card to Apple Pay®, Google PayTM or Samsung Pay® to ' +
    'make payments with your phone.',
  '1650.features.2':
    "Visa's Zero Liability Policy and " +
    '<a href="https://www.regions.com/personal_banking/debit_prepaid_chip_cards.rf" target="_blank" ' +
    'rel="noopener noreferrer">Chip Technology</a>',
  '1650.features.3':
    'Card Customization Options with <a href="https://yourpix.regions.com/" target="_blank" ' +
    'rel="noopener noreferrer">Regions YourPix Studio®</a> available for only $10',
  '1650.disclosures.count': 0,

  '1651.name': 'Overdraft Services',
  '1651.url': 'https://www.regions.com/small-business/overdraft-options',
  '1651.description.abbreviated':
    'We understand that a business owner’s life is busy. Forgetting to record a check ' +
    'or debit can easily happen to anyone, but Regions Standard Overdraft Coverage and Regions Overdraft Protection ' +
    'provide options for payment of items when your small business account is short of available funds.',
  '1651.description':
    'If you choose to enroll in Regions Overdraft Protection (“ODP”), your business checking ' +
    'account will be linked to a designated business funding account at Regions, such as another deposit account ' +
    '(including a savings or money market account), credit card account, or a line of credit. ODP may be used to ' +
    'authorize and/or to pay CheckCard and ATM transactions if your checking account lacks sufficient available funds. ' +
    'ODP may be used to pay checks, ACH transactions, and other items when payment of those items would overdraw the checking account.',
  '1651.features.count': 2,
  '1651.features.1': ' Provides peace of mind',
  '1651.features.2': ' Protects your business account from being overdrawn',
  '1651.disclosures.count': 0,

  '1636.name': 'Priority Banking for Business',
  '1636.url': 'https://www.regions.com/promo/priority-banking-for-business',
  '1636.description.abbreviated':
    'A preferred-customer program that delivers a high level of personal service along ' +
    'with special savings and earnings opportunities...all at no additional cost to you.',
  '1636.description':
    'A preferred customer program that delivers a high level of personal service along with special ' +
    'savings and earnings opportunities, all at no additional cost to you.',
  '1636.features.count': 3,
  '1636.features.1': 'Personal attention and expertise from your dedicated Priority Banker',
  '1636.features.2':
    'Fast, friendly assistance from the Regions Priority Banking Center® with extended hours ' +
    'available seven days a week including bank holidays',
  '1636.features.3': 'Enhanced mobile banking features including higher limits of mobile deposits',
  '1636.disclosures.count': 0,

  '1647.name': 'Rewards Multiplier',
  '1647.url': 'https://www.regions.com/personal-banking/regions-rewards/rewards-multiplier',
  '1647.description.abbreviated': 'The more your business banks with Regions, the more points it could earn.',
  '1647.description':
    'You work hard for your money. Now your money can work for you. The more you maintain in eligible Regions ' +
    'Bank personal deposit accounts such as savings, money market, IRA, or checking, the more Rewards points you ' +
    'could earn onpurchases1 made with your credit card.',
  '1647.features.count': 1,
  '1647.features.1': 'You could multiply the points you earn for your Regions Prestige credit card purchases. Then redeem points through the Relationship Rewards Catalog for cash, travel, merchandise, or gift cards.',
  '1647.disclosures.count': 1,
  '1647.disclosures.1': 'Points are not awarded for any purchases of items that can be traded right away for cash (such as wire transfers, money orders, traveler’s checks, lottery tickets or casino chips) or any other cash advances, balance transfers, fees, interest charges, or unauthorized or fraudulent purchases.',
  '1647.url.termsAndConditions': 'https://www.regions.com/-/media/pdfs/terms/Regions-Rewards-Multiplier-Terms-and-Conditions.pdf?la=en&revision=56360e57-f160-464a-b6e2-dfa1000c00f9&hash=827F5E30775F609CE76EF268368C1DD9',

  '1685.name': 'Article:  Finance, Operations, Risk Management, Innovation',
  '1685.url': 'https://www.regions.com/Insights/Small-Business#Finance',
  '1685.features.count': 0,
  '1685.disclosures.count': 0,

  /**
   * Business Treasury Products [EVERYDAY BANKING]
   */

  '1637.name': 'Regions Merchant Services',
  '1637.url': 'https://cloud.na.elavon.com/regionsbank',
  '1637.url.quickGuide': 'https://www.regions.com/virtualdocuments/QuickGuide-MerchantServices.pdf',
  '1637.description.abbreviated':
    'At Regions Merchant Services, we don’t want you to miss an opportunity to connect ' +
    'with your customers, no matter where your business takes you. We make payments fast and easy. And with so many ' +
    'payment options available, your customers have the flexibility to pay however they choose.<sup>1</sup>',
  '1637.description':
    'With Merchant Services, you can accept cards and electronic payments from customers and ' +
    'receive funds directly into any checking account. Funds are generally available to your business the same day or ' +
    'next business day when credited to a Regions checking account.<sup>1</sup>',
  '1637.features.count': 5,
  '1637.features.1':
    'The latest in payment technology, including smart terminals and in-person, online and mobile- ' +
    'and tablet-based payment solutions that grow with your business',
  '1637.features.2': '24/7/365 customer service',
  '1637.features.3': 'Same-day or next-day business funding with no additional fees',
  '1637.features.4': 'Security suite to help you better protect customer card data from breach',
  '1637.features.5': 'Loyalty programs to help you grow your business',
  '1637.disclosures.count': 1,
  '1637.disclosures.1':
    'Regions Merchant Services are provided by Elavon. All transactions are subject to the ' +
    'operating rules and regulations of the applicable payment and processing network.',

  '1662.name': 'Paycor Payroll and HR Services',
  '1662.url': 'https://www.dropbox.com/s/0kseo09gp8fyxip/Regions_Update_720p.mov?dl=0',
  '1662.description.abbreviated':
    'Regions has established a relationship with Paycor<sup>1</sup> to offer a ' + 'simplified, full-service solution.',
  '1662.description':
    'Regions has established a relationship with Paycor to offer a simplified, full-service ' +
    'solution providing you with an easy-to-use application that gives you immediate and secure access to HR, ' +
    'payroll, timekeeping and reporting information. Plus, you can manage all your HR and payroll tasks quickly ' +
    'and easily, whenever and wherever you choose. If you ever have any questions or need help, you’ll have a ' +
    'dedicated payroll and HR specialist who knows you and your organization.',
  '1662.features.count': 3,
  '1662.features.1':
    'Easy-to-use application that gives you immediate and secure access to Human Resources, payroll, ' +
    'timekeeping and reporting information',
  '1662.features.2': 'Manage all your HR and payroll tasks quickly and easily, whenever and wherever you choose',
  '1662.features.3':
    'If you ever have any questions or need help, you’ll have a dedicated payroll and HR specialist ' +
    'who knows you and your organization',
  '1662.disclosures.count': 1,
  '1662.disclosures.1':
    'Paycor Payroll and HR Services are provided by Paycor. Regions customers will receive ' +
    'preferential pricing when your payroll is funded through a Regions Business Checking Account. While these ' +
    'services are made available to Regions Bank customers, Regions Bank does not provide the product or service ' +
    'and makes no representations or warranties regarding your use of Paycor Services.',

  '1688.name': 'Commercial Banking Solutions Relationship Manager',
  '1688.url.pricing': pricing,
  '1688.url.deposit': deposit,
  '1688.description.abbreviated':
    'Commercial Banking Solutions team delivers an expert banker with the dial of the ' +
    'phone.  Bankers have a clear understanding of your unique needs.',
  '1688.description':
    'Commercial Banking Solutions team delivers an expert banker with the dial of the phone. ' +
    'Bankers have a clear understanding of your unique needs.',
  '1688.features.count': 3,
  '1688.features.1': 'Obtain guidance and perspective by phone, giving you and your business flexibility',
  '1688.features.2': 'Ability to leverage a range of business partners to provide specific expertise',
  '1688.features.3': 'Customized solutions for your business’ unique needs',
  '1688.disclosures.count': 0,

  '1444.name': 'Business Analyzed Checking',
  '1444.url': 'https://www.regions.com/treasury-management/deposit-services/commercial-analyzed-checking',
  '1444.url.pricing': pricing,
  '1444.url.deposit': deposit,
  '1444.description.abbreviated':
    'Businesses with large balances and large transaction volumes that want an earnings ' +
    'credit allowance to help offset service charges.',
  '1444.description':
    'This account provides unlimited transactions, ability to link Treasury Management services, ' +
    'web access to account management through iTreasury or Regions Business Online, account balances use an earnings ' +
    'credit rate to offset service fees; following fee offset, the account will either earn interest or pay remaining ' +
    'service charges not covered by balances, and the security of FDIC insurance coverage up to the maximum amount ' +
    'permitted by law.',
  '1444.features.count': 3,
  '1444.features.1': 'Earnings credit allowance to help offset service charges',
  '1444.features.2': 'Link to Treasury Management Services',
  '1444.features.3': 'Online account access through iTreasury Small Business or iTreasury',
  '1444.disclosures.count': 1,
  '1444.disclosures.1': `Service fees apply. See <a href='${pricing}' target='_blank'>pricing schedule</a> or the current <a href='${deposit}' target='_blank'>Regions Deposit Agreement</a> for complete terms.`,

  '1652.name': 'Online Business Services',
  '1652.url': 'https://www.regions.com/digital-banking/online-banking-business-services',
  '1652.description.abbreviated':
    'Regions Online Banking for Business gives you freedom to bank where you want, ' + 'when you want.',
  '1652.description':
    'Regions Online Banking for Business gives you freedom to bank where you want, when you want. ' +
    'Take advantage of a safe and secure way to check your business account balances, pay bills and transfer funds. ' +
    'It offers a personal small business experience, allowing all of your business and personal accounts to be viewed ' +
    'through one login — but conveniently organized based on how you use them.',
  '1652.features.count': 3,
  '1652.features.1':
    'Online Banking Business Services allow you to customize your small business cash management tool kit',
  '1652.features.2': 'Convenient for small business owners on the go',
  '1652.features.3': 'Log in to Online Banking and select Products Tab to get started',
  '1652.disclosures.count': 0,

  '1653.name': 'iTreasury SB',
  '1653.url': 'https://www.regions.com/treasury-management/itreasury-small-business',
  '1653.description.abbreviated':
    'With Regions iTreasury® Small Business (iTreasury SB), you can effectively manage ' +
    'the cash flow of your business and enjoy peace of mind with the advanced fraud prevention options that Regions ' +
    'iTreasury SB provides — all through one point of control.',
  '1653.description': '',
  '1653.features.count': 3,
  '1653.features.1': 'Detailed information reporting',
  '1653.features.2': 'Easy ability to transfer funds',
  '1653.features.3': 'Faster payments',
  '1653.features.4': 'Increased fraud protection',
  '1653.disclosures.count': 0,

  '1654.name': 'iTreasury',
  '1654.url': 'https://www.regions.com/treasury-management/itreasury',
  '1654.description.abbreviated':
    'With Regions iTreasury®, you can easily manage your company’s cash flow with ' + 'convenience and control.',
  '1654.description': '',
  '1654.features.count': 4,
  '1654.features.1': 'Dashboard customization',
  '1654.features.2': 'Flexible security controls',
  '1654.features.3': 'Streamline payments',
  '1654.features.4': 'Mobile-enabled',
  '1654.disclosures.count': 0,

  '1655.name': 'Online Statements',
  '1655.description.abbreviated':
    'An Online Statement is an electronic version of your periodic statement available ' +
    'through Regions Online Banking. This exact copy of your paper statement is presented in a secure environment ' +
    'and captures information into a PDF file you can view, print or save at your convenience.',
  '1655.description': '',
  '1655.features.count': 3,
  '1655.features.1': 'Convenient access to the exact copy of your paper statement',
  '1655.features.2': 'View and access your statement in a secure environment',
  '1655.features.3': 'Ability to view, print and save statements',
  '1655.disclosures.count': 0,

  '1659.name': 'Wire Transfers',
  '1659.url': 'https://www.regions.com/treasury-management/disbursing-funds/wire-transfer',
  '1659.description.abbreviated':
    'Send funds electronically from your small business banking account to another institution.',
  '1659.description':
    'Settle large dollar transactions quickly, maximize earnings and reduce borrowing costs with ' +
    'Regions Wire Transfer service.',
  '1659.features.count': 3,
  '1659.features.1': 'Settle large dollar transactions quickly and securely',
  '1659.features.2': 'Enhanced administration',
  '1659.features.3': 'Initiate one-time payments and establish templates for repetitive wires',
  '1659.disclosures.count': 0,

  '1657.name': 'People and Permissions',
  '1657.url': 'https://www.regions.com/digital-banking/online-banking-business-services',
  '1657.description.abbreviated':
    'Allow trusted employees to manage your accounts, make payments and complete ' +
    'transactions with limited or full functionality.',
  '1657.description': '',
  '1657.features.count': 3,
  '1657.features.1': 'Customize employee access based on job functions',
  '1657.features.2': 'Add an approval tier to ACH and Wire Transfer payments',
  '1657.features.3': 'Improve security of confidential information',
  '1657.disclosures.count': 0,

  '1660.name': 'Check Inspect',
  '1660.url': 'https://www.regions.com/digital-banking/online-banking-business-services',
  '1660.description.abbreviated':
    'Protect your business from losses associated with fraudulent checks by using ' + 'advanced check monitoring.',
  '1660.description': '',
  '1660.features.count': 2,
  '1660.features.1': 'Receive notification of checks posted to your account',
  '1660.features.2': 'Return fraudulent items conveniently online',
  '1660.disclosures.count': 0,

  '1661.name': 'Positive Pay',
  '1661.url': 'https://www.regions.com/treasury-management/fraud-prevention-resources/positive-pay',
  '1661.description.abbreviated':
    'Help protect your business from loss associated with paper-based fraud with ' + 'Regions Positive Pay solutions.',
  '1661.description':
    'Regions Positive Pay works by comparing and verifying the checks you issue to the checks ' +
    'presented for payment against your account. Any check that does not match your issue file in dollar amount, ' +
    'serial number or payee name is reported online through Regions iTreasury®, Regions iTreasury® Small Business, ' +
    'or Online Banking for Business’ Check Inspect as an exception item.',
  '1661.features.count': 2,
  '1661.features.1':
    'Provides additional protection against counterfeit or amount-altered checks presented at the ' +
    'branch’s cash line',
  '1661.features.2':
    'View exception items online at your convenience each morning to help prevent check fraud loss. ' +
    'Verify checks for legitimacy and pay or return items electronically as needed, preventing check-based fraud ' +
    'before it can occur',

  '1658.name': 'Automated Clearing House (ACH)',
  '1658.url': 'https://www.regions.com/treasury-management/disbursing-funds/ach-origination',
  '1658.description.abbreviated':
    'Conveniently create electronic transfers for vendor and supplier payments and ' +
    'payments to other payees in a timely and reliable manner using Regions ACH (Automated Clearing House) Origination.',
  '1658.description':
    'By directly depositing funds into employee payroll and vendor accounts, you reduce costs ' +
    'from check production, reconciliation and postage.  Plus, more timely payments will improve service and cash ' +
    'flow predictability',
  '1658.features.count': 3,
  '1658.features.1': 'Originate Multiple payment types',
  '1658.features.2': 'Low-cost option for transaction settlement',
  '1658.features.3':
    'Pay suppliers directly, reducing the cost and volume of checks and the risk of potential paper-based fraud',
  '1658.disclosures.count': 0,

  '1663.name': 'Business Mobile Deposit',
  '1663.url': 'https://www.regions.com/treasury-management/collecting-funds/quick-deposit-mobile',
  '1663.description.abbreviated':
    'Regions Mobile Deposit is an easy way to use the Regions mobile app to deposit ' +
    'checks into your checking, savings, money market account or to load funds to a Now Card. Other commonly used ' +
    'terms for mobile deposit are "remote deposit" or "remote deposit capture."',
  '1663.description':
    'Regions Mobile Deposit is an easy way to use the Regions mobile app to deposit checks into ' +
    'your checking, savings, money market account or to load funds to a Now Card. Other commonly used terms for ' +
    'mobile deposit are "remote deposit" or "remote deposit capture."',
  '1663.features.count': 3,
  '1663.features.1': 'Deposit checks remotely using mobile device',
  '1663.features.2': 'Improves cash flow',
  '1663.features.3': 'Saves time',
  '1663.disclosures.count': 0,

  '1686.name': 'Business Quick Deposit® Mobile',
  '1686.url': 'https://www.regions.com/treasury-management/collecting-funds/quick-deposit-mobile',
  '1686.description.abbreviated':
    'Make deposits at your convenience using your mobile device<sup>1</sup>, and enjoy the advantage of the robust' +
    'research reporting features that are included with the traditional desktop Quick Deposit solution, ' +
    'plus gain robust reporting and research capabilities.',
  '1686.description':
    'Regions Mobile Deposit is an easy way to use the Regions mobile app to deposit checks into ' +
    'your checking, savings, money market account or to load funds to a Now Card. Other commonly used terms for ' +
    'mobile deposit are "remote deposit" or "remote deposit capture."',
  '1686.features.count': 2,
  '1686.features.1': 'Deposit multiple checks 24/7 from anywhere in the U.S.',
  '1686.features.2': 'Submit checks before 8 p.m. CT for same-day ledger credit<sup>2</sup>',
  '1686.disclosures.count': 2,
  '1686.disclosures.1':
    "Compatible device required. Your mobile carrier's message and data fees may apply.",
  '1686.disclosures.2':
  'Deposits by 8 p.m. CT are considered as same business day. Deposits are subject to verification. ' +
  'Saturdays, Sundays and federal holidays are not business days.',

  '1664.name': 'Quick Deposit',
  '1664.url': 'https://www.regions.com/treasury-management/collecting-funds/quick-deposit',
  '1664.description.abbreviated': 'Streamline your business check deposit process and improve cash flow',
  '1664.description':
    'Scan and deposit checks directly into your business account from your home or office ' +
    'using a special scanner connected to your computer. Get faster access to funds',
  '1664.features.count': 3,
  '1664.features.1': 'Deposit multiple checks',
  '1664.features.2': 'Eliminates time consuming trips to the bank',
  '1664.features.3': 'Increase working capital and improve cash flow',
  '1664.disclosures.count': 0,

  '1679.name': 'Vault Services',
  '1679.url': 'https://www.regions.com/treasury-management/collecting-funds/vault-services',
  '1679.description.abbreviated':
    'Help improve cash flow and funds availability, reduce cash management costs ' +
    'and reduce your exposure to loss with Regions Vault Services',
  '1679.description':
    'Managing high-volume cash deposits manually represents a significant security risk. ' +
    'Cash-intensive operations need to deposit cash at a local branch, entrust an employee to make cash deposits ' +
    'or pay for a service provider to handle cash deposits. With Regions Vault Services Remote Cash Capture, you ' +
    'can streamline your cash handling operations by automatically transmitting deposits electronically from each of ' +
    'your business locations',
  '1679.features.count': 3,
  '1679.features.1': 'You collect more than $20,000 cash each month',
  '1679.features.2': 'Increased security and employee safety',
  '1679.features.3': 'Improve cash flow and funds availability and benefit from next-day credit',
  '1679.disclosures.count': 0,

  '1656.name': 'QuickBooks File Download',
  '1656.url': 'https://www.regions.com/digital-banking/quickbooks',
  '1656.description.abbreviated':
    'Manage payroll, invoices and daily business transactions using an accounting ' +
    'software program that connects to your small business banking accounts through online banking.',
  '1656.description':
    'You can use your Quicken or QuickBooks software to connect to Regions and download your ' +
    'account information, as well as send transfer or payment instructions to Regions online.',
  '1656.features.count': 3,
  '1656.features.1': 'Manage sales and expenses',
  '1656.features.2': 'Keep track of daily transactions',
  '1656.features.3': 'Invoice customers, pay bills, generate tax reports',
  '1656.disclosures.count': 0,

  '1693.name': 'QuickBooks Download',
  '1693.url': 'https://www.regions.com/digital-banking/quickbooks',
  '1693.description.abbreviated':
    'Manage payroll, invoices and daily business transactions using an accounting ' +
    'software program that connects to your small business banking accounts through online banking.',
  '1693.description':
    'You can use your Quicken or QuickBooks software to connect to Regions and download your ' +
    'account information, as well as send transfer or payment instructions to Regions online.',
  '1693.features.count': 3,
  '1693.features.1': 'Manage sales and expenses',
  '1693.features.2': 'Keep track of daily transactions',
  '1693.features.3': 'Invoice customers, pay bills, generate tax reports',
  '1693.disclosures.count': 0,

  /**
   * Business Credit Card Products [BORROWING SMARTER]
   */

  '1638.name': 'Regions Visa® Business Enhanced Credit Card',
  '1638.url': 'https://www.regions.com/small_business/bus_enhanced.rf',
  '1638.url.quickGuide': 'https://www.regions.com/virtualdocuments/QuickGuide-BusinessCreditCard.pdf',
  '1638.url.pricing': pricing,
  '1638.description.abbreviated':
    'For new or established businesses who want to improve cash flow, better manage ' +
    'expenses, and gain more financial control while earning rewards for purchases<sup>1</sup>.',
  '1638.description':
    'The Regions Visa® Business Enhanced Credit Card with Relationship Rewards gives you added ' +
    "control for your business<sup>1</sup>.  Improve your cash flow and enhance the way you manage your business' " +
    ' finances. And, because it comes with Regions Relationship Rewards®, you can earn points for all your ' +
    'qualifying purchases<sup>2</sup> made with your card – from gas to office supplies.<br>For additional benefits ' +
    'associated with your Regions Business Credit Card, visit ' +
    '<a href="https://www.regions.com/virtualDocuments/Business-Credit-Card-Guide-to-Benefits.pdf" target="_blank" ' +
    'rel="noopener nofollow">Visa’s Guide to Benefits</a>.',
  '1638.features.count': 4,
  '1638.features.1': 'Zero percent APR on purchases for the first six months',
  '1638.features.2': 'No annual fee',
  '1638.features.3': 'Participation in the Regions Relationship Rewards program<sup>2</sup>',
  '1638.features.4':
    '<a href="https://visasavingsedge.com/e/members/article.php?sid=92XXdKrlo92&xid=215000" ' +
    'target="_blank" rel="noopener nofollow">Visa SavingsEdge</a>: Save up to 15% on business purchases',
  '1638.disclosures.count': 2,
  '1638.disclosures.1':
    'Regions Merchant Services are provided by Elavon. All transactions are subject to the ' +
    'operating rules and regulations of the applicable payment and processing network.',
  '1638.disclosures.2':
    'Qualifying purchases do not include purchases of items that can be traded right away for ' +
    'cash (such as wire transfers, money orders, traveler’s checks, lottery tickets or casino chips) any unauthorized ' +
    'purchases, or any fees or interest charges.',

  '1639.name': 'Regions Visa® Business Credit Card',
  '1639.url': 'https://www.regions.com/small_business/bus_creditcard.rf',
  '1639.url.quickGuide': 'https://www.regions.com/virtualdocuments/QuickGuide-BusinessCreditCard.pdf',
  '1639.url.pricing': pricing,
  '1639.description.abbreviated':
    'For businesses who want added financial control for their business.<sup>1</sup> ' +
    'Improve cash flow and enhance the way you manage and track business expenses. Regions makes it easy with online ' +
    'account management and no annual fee.',
  '1639.description':
    'The Regions Visa® Business credit card1 provides greater financial control, improved cash flow ' +
    'and a better solution for managing your business expenses. Regions makes it easy; no annual fees, no foreign ' +
    'transaction fees and easy online account management.<br>For additional benefits associated with your Regions ' +
    'Business Credit Card, visit ' +
    '<a href="https://www.regions.com/virtualDocuments/Business-Credit-Card-Guide-to-Benefits.pdf" target="_blank" ' +
    'rel="noopener nofollow">Visa\'s Guide to Benefits</a>.',
  '1639.features.count': 3,
  '1639.features.1': 'Zero percent APR on purchases for the first six months',
  '1639.features.2': 'No annual fee',
  '1639.features.3': 'Convenient way to simplify expense management',
  '1639.disclosures.count': 1,
  '1639.disclosures.1':
    'Credit cards are subject to credit approval and terms and conditions of the Credit Card Agreement.',

  /**
   * Business Loans and Lines [BORROWING SMARTER]
   */

  '1678.name': 'Commercial Loans and Lines',
  '1678.url': 'https://www.regions.com/commercial-banking/commercial-lending',
  '1678.description.abbreviated':
    'Regions offers a variety of commercial lending programs that can help you meet ' +
    'your short- and long-term growth strategies. Our dedicated team of professionals can help you decide which of ' +
    'our financing options is best for your needs.',
  '1678.description': '',
  '1678.features.count': 2,
  '1678.features.1': 'Needing a term loan to make a major investment in your business or to finance an acquisition.',
  '1678.features.2': 'Needing a line of credit to support working capital needs.',
  '1678.disclosures.count': 0,

  '1670.name': 'Business Real Estate Loan',
  '1670.url': 'https://www.regions.com/commercial-banking/real-estate-banking/real-estate-corporate-banking',
  '1670.url.quickGuide': 'https://www.regions.com/virtualdocuments/QuickGuide-Business-Loan.pdf',
  '1670.description.abbreviated':
    'The Regions Real Estate Corporate Banking team serves as a strategic advisor to ' +
    'over 100 public and private real estate investment trusts (REITs) and institutional real estate funds. We offer ' +
    'a full suite of commercial real estate products and financing solutions to support your growing business in every way.',
  '1670.description': '',
  '1670.features.count': 2,
  '1670.features.1': 'Looking to purchase owner occupied real estate',
  /* eslint-disable-next-line no-unused-vars */
  '1670.features.1.rule': answers => true,
  '1670.features.2': 'Looking refinance owner occupied real estate',
  /* eslint-disable-next-line no-unused-vars */
  '1670.features.2.rule': answers => true,
  '1670.disclosures.count': 0,

  '1667.name': 'Equipment Loan',
  '1667.url': 'https://www.regions.com/commercial-banking/equipment-financing',
  '1667.url.quickGuide': 'https://www.regions.com/virtualdocuments/QuickGuide-Business-Loan.pdf',
  '1667.description.abbreviated':
    'Regions Equipment Financing Services gives businesses the flexibility to secure ' +
    'the capital they need to purchase new equipment while maximizing operating cash flow and minimizing tax liability. ' +
    'We offer a variety of equipment leasing programs to meet your needs.',
  '1667.description': '',
  '1667.features.count': 2,
  '1667.features.1': 'Looking to purchase new or used equipment',
  /* eslint-disable-next-line no-unused-vars */
  '1667.features.1.rule': answers => true,
  '1667.features.2': 'Looking refinance equipment loan',
  /* eslint-disable-next-line no-unused-vars */
  '1667.features.2.rule': answers => true,
  '1667.disclosures.count': 0,

  '1668.name': 'Vehicle Loan',
  '1668.url': 'https://www.regions.com/small-business/small-business-financing/loans-and-lines-of-credit',
  '1668.url.quickGuide': 'https://www.regions.com/virtualdocuments/QuickGuide-Business-Loan.pdf',
  '1668.description.abbreviated': 'For businesses who are looking to purchase or refinance new or used vehicles',
  '1668.description': '',
  '1668.features.count': 2,
  '1668.features.1': 'Looking to purchase new or used company vehicles',
  /* eslint-disable-next-line no-unused-vars */
  '1668.features.1.rule': answers => true,
  '1668.features.2': 'Looking to refinance new or used company vehicles',
  /* eslint-disable-next-line no-unused-vars */
  '1668.features.2.rule': answers => true,
  '1668.disclosures.count': 0,

  '1669.name': 'Specialty Vehicle Loan',
  '1669.url': 'https://www.regions.com/small-business/small-business-financing/loans-and-lines-of-credit',
  '1669.url.quickGuide': 'https://www.regions.com/virtualdocuments/QuickGuide-Business-Loan.pdf',
  '1669.description.abbreviated':
    'A term loan to purchase or refinance a new or used specialty vehicle. A specialty ' +
    'vehicle is a vehicle for company use that is rated more than ½ ton',
  '1669.description': '',
  '1669.features.count': 2,
  '1669.features.1': 'Looking to purchase new or used specialty vehicle',
  /* eslint-disable-next-line no-unused-vars */
  '1669.features.1.rule': answers => true,
  '1669.features.2': 'Looking to refinance new or used specialty vehicle',
  /* eslint-disable-next-line no-unused-vars */
  '1669.features.2.rule': answers => true,
  '1669.disclosures.count': 0,

  '1672.name': 'Regions Business Line - Real Estate Secured',
  '1672.url': 'https://www.regions.com/small-business/small-business-financing/loans-and-lines-of-credit',
  '1672.url.quickGuide': 'https://www.regions.com/virtualdocuments/QuickGuide-Business-Loan.pdf',
  '1672.description.abbreviated':
    'With a line of credit, you borrow as little or as much as you need, up to your ' +
    'available credit limit and your payment amount adjusts based on the balance owed. Funds may be borrowed, repaid, ' +
    'and borrowed again. The line is secured with owner occupied real estate.',
  '1672.description': '',
  '1672.features.count': 2,
  '1672.features.1': 'Needing a line of credit to support working capital needs',
  /* eslint-disable-next-line no-unused-vars */
  '1672.features.1.rule': answers => true,
  '1672.features.2': 'Looking to refinance a line of credit to support working capital needs',
  /* eslint-disable-next-line no-unused-vars */
  '1672.features.2.rule': answers => true,
  '1672.disclosures.count': 0,

  '1671.name': 'Cash Secured Loan',
  '1671.url': 'https://www.regions.com/small-business/small-business-financing/loans-and-lines-of-credit',
  '1671.url.quickGuide': 'https://www.regions.com/virtualdocuments/QuickGuide-Business-Loan.pdf',
  '1671.description.abbreviated':
    'A Regions Savings Secured Loan is an installment loan which allows you to use ' +
    'funds from your Regions Savings or Money Market account as collateral while still maintaining a balance in that ' +
    'account. The total amount of the loan is secured and the funds used as collateral from your Savings or Money ' +
    'Market account are not available for withdrawal during the life of the loan.',
  '1671.description': '',
  '1671.features.count': 2,
  '1671.features.1': 'Supports working capital needs',
  '1671.features.2': 'Offers lower interest rates (secured with CD)',
  '1671.disclosures.count': 0,

  '1673.name': 'Cash Secured Line of Credit',
  '1673.url': 'https://www.regions.com/small-business/small-business-financing/loans-and-lines-of-credit',
  '1673.url.quickGuide': 'https://www.regions.com/virtualdocuments/QuickGuide-Business-Loan.pdf',
  '1673.description.abbreviated': '',
  '1673.description': '',
  '1673.features.count': 2,
  '1673.features.1': 'Supports working capital needs',
  '1673.features.2': 'Offers lower interest rates (secured with CD)',
  '1673.disclosures.count': 0,

  '1675.name': 'Farm/Agricultural Loans and Lines',
  '1675.url': 'https://www.regions.com/small-business/small-business-financing/loans-and-lines-of-credit',
  '1675.url.quickGuide': 'https://www.regions.com/virtualdocuments/QuickGuide-Business-Loan.pdf',
  '1675.description.abbreviated':
    'As one of the top agricultural banks in the United States, Regions has the ' +
    'products, terms and expertise to help your farm rise to bigger and better things.',
  '1675.description':
    'Your agricultural relationship manager is supported by a team of specialists in capital ' +
    'markets, lending and treasury management who know your business, goals and concerns, so you can grow the kind ' +
    'of relationship that leads to success.',
  '1675.features.count': 2,
  '1675.features.1': 'Obtain working capital for crops and agricultural solutions',
  '1675.features.2': 'To purchase or refinance farm land',
  '1675.disclosures.count': 0,

  '1677.name': 'SBA Express Loans and Lines',
  '1677.url':
    'https://www.regions.com/small-business/small-business-financing/small-business-loan/apply-for-an-SBA-express-loan',
  '1677.description.abbreviated':
    'An SBA Express Loan is a loan or line of credit between $35,000 and $350,000. ' +
    'The funds may be used for financing business acquisitions, equipment, debt refinance, working capital, inventory ' +
    'and leasehold improvements.',
  '1677.description': '',
  '1677.features.count': 2,
  '1677.features.1': 'You are interested in funds backed by an SBA guarantee',
  '1677.features.2':
    'Term loan or lines offered to help Small Businesses acquire financing who otherwise would not ' +
    'qualify because of payment size and/or down payment requirements',
  '1677.disclosures.count': 0,

  '1674.name': 'Regions Business Line of Credit',
  '1674.url': 'https://www.regions.com/small-business/small-business-financing/loans-and-lines-of-credit',
  '1674.url.quickGuide': 'https://www.regions.com/virtualdocuments/QuickGuide-Business-Loan.pdf',
  '1674.description.abbreviated':
    'With a line of credit, you borrow as little or as much as you need, up to your ' +
    'available credit limit and your payment amount adjusts based on the balance owed. Funds may be borrowed, ' +
    'repaid, and borrowed again.',
  '1674.description': '',
  '1674.features.count': 3,
  '1674.features.1': 'A line of credit provides flexibility ',
  '1674.features.2': 'Collateral may not be required',
  '1674.features.3': 'Gives you peace of mind for unexpected expenses',
  '1674.disclosures.count': 0,

  /**
   * Calculators and Insights [BORROWING SMARTER]
   */

  '1680.name': 'Calculate: Business Loan Calculator',
  '1680.url': 'https://www.regions.com/Insights/Small-Business/Business-Finance-Calculators/Business-Loan-Calculator',
  '1680.description.abbreviated': '',
  '1680.description': '',
  '1680.features.count': 0,
  '1680.disclosures.count': 0,

  '1681.name': 'Calculate: How to Calculate Business Loan Repayment',
  '1681.url':
    'https://www.regions.com/Insights/Small-Business/Business-Finance-Calculators/How-to-Calculate-Business-Loan-Repayment',
  '1681.description.abbreviated': '',
  '1681.description': '',
  '1681.features.count': 0,
  '1681.disclosures.count': 0,

  '1682.name': 'Calculate: Business Debt Consolidation',
  '1682.url':
    'https://www.regions.com/Insights/Small-Business/Business-Finance-Calculators/How-to-Calculate-Business-Debt-Consolidation',
  '1682.description.abbreviated': '',
  '1682.description': '',
  '1682.features.count': 0,
  '1682.disclosures.count': 0,

  '1683.name': 'Calculate: Compare Two Business Loans',
  '1683.url':
    'https://www.regions.com/Insights/Small-Business/Business-Finance-Calculators/How-to-Compare-Two-Business-Loans',
  '1683.description.abbreviated': '',
  '1683.description': '',
  '1683.features.count': 0,
  '1683.disclosures.count': 0,

  '1684.name': 'Calculate: Are Credit Card Balance Transfers Worth it?',
  '1684.url': 'https://www.regions.com/Insights/Personal/Debt-Calculators/are-credit-card-balance-transfers-worth-it',
  '1684.description.abbreviated': '',
  '1684.description': '',
  '1684.features.count': 0,
  '1684.disclosures.count': 0,
};
